/* tslint:disable */
/* eslint-disable */
/**
 * Clinic Example API
 * This is a Clinic server.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI } from './base';
/**
 * ApiKeyApi - axios parameter creator
 * @export
 */
export const ApiKeyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * list upload key of the user in current organizatioin
         * @summary List upload key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidKeysGet: (xCsrfToken_1, oid_1, limit_1, page_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, limit_1, page_1, ...args_1], void 0, function* (xCsrfToken, oid, limit, page, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidKeysGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidKeysGet', 'oid', oid);
            const localVarPath = `/orgs/{oid}/keys`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create api key
         * @summary Delete api key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} id key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidKeysIdDelete: (xCsrfToken_1, oid_1, id_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, id_1, ...args_1], void 0, function* (xCsrfToken, oid, id, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidKeysIdDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidKeysIdDelete', 'oid', oid);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orgsOidKeysIdDelete', 'id', id);
            const localVarPath = `/orgs/{oid}/keys/{id}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create api key
         * @summary Create api key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidKeysPost: (xCsrfToken_1, oid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, ...args_1], void 0, function* (xCsrfToken, oid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidKeysPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidKeysPost', 'oid', oid);
            const localVarPath = `/orgs/{oid}/keys`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ApiKeyApi - functional programming interface
 * @export
 */
export const ApiKeyApiFp = function (configuration) {
    const localVarAxiosParamCreator = ApiKeyApiAxiosParamCreator(configuration);
    return {
        /**
         * list upload key of the user in current organizatioin
         * @summary List upload key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidKeysGet(xCsrfToken, oid, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidKeysGet(xCsrfToken, oid, limit, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * create api key
         * @summary Delete api key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} id key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidKeysIdDelete(xCsrfToken, oid, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidKeysIdDelete(xCsrfToken, oid, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * create api key
         * @summary Create api key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidKeysPost(xCsrfToken, oid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidKeysPost(xCsrfToken, oid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ApiKeyApi - factory interface
 * @export
 */
export const ApiKeyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ApiKeyApiFp(configuration);
    return {
        /**
         * list upload key of the user in current organizatioin
         * @summary List upload key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidKeysGet(xCsrfToken, oid, limit, page, options) {
            return localVarFp.orgsOidKeysGet(xCsrfToken, oid, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * create api key
         * @summary Delete api key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} id key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidKeysIdDelete(xCsrfToken, oid, id, options) {
            return localVarFp.orgsOidKeysIdDelete(xCsrfToken, oid, id, options).then((request) => request(axios, basePath));
        },
        /**
         * create api key
         * @summary Create api key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidKeysPost(xCsrfToken, oid, options) {
            return localVarFp.orgsOidKeysPost(xCsrfToken, oid, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ApiKeyApi - object-oriented interface
 * @export
 * @class ApiKeyApi
 * @extends {BaseAPI}
 */
export class ApiKeyApi extends BaseAPI {
    /**
     * list upload key of the user in current organizatioin
     * @summary List upload key
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {number} [limit] the count per page
     * @param {number} [page] the page index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeyApi
     */
    orgsOidKeysGet(xCsrfToken, oid, limit, page, options) {
        return ApiKeyApiFp(this.configuration).orgsOidKeysGet(xCsrfToken, oid, limit, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create api key
     * @summary Delete api key
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {number} id key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeyApi
     */
    orgsOidKeysIdDelete(xCsrfToken, oid, id, options) {
        return ApiKeyApiFp(this.configuration).orgsOidKeysIdDelete(xCsrfToken, oid, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create api key
     * @summary Create api key
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeyApi
     */
    orgsOidKeysPost(xCsrfToken, oid, options) {
        return ApiKeyApiFp(this.configuration).orgsOidKeysPost(xCsrfToken, oid, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ClusterApi - axios parameter creator
 * @export
 */
export const ClusterApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get cluster basic information by cluster id (lightweight direct DB lookup)
         * @summary Get cluster basic info by ID
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersCidGet: (xCsrfToken_1, oid_1, cid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('clustersCidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('clustersCidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('clustersCidGet', 'cid', cid);
            const localVarPath = `/clusters/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list dashboard user can access
         * @summary list dashboard user can access
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [startTime] startTime of dashboard show
         * @param {number} [endTime] endTime of dashboard show
         * @param {string} [version] tidb version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDashboardGet: (xCsrfToken_1, oid_1, cid_1, startTime_1, endTime_1, version_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, startTime_1, endTime_1, version_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, startTime, endTime, version, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidDashboardGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidDashboardGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidDashboardGet', 'cid', cid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/dashboard`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list available dashboard version
         * @summary list available dashboard version
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDashboardVersionsGet: (xCsrfToken_1, oid_1, cid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidDashboardVersionsGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidDashboardVersionsGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidDashboardVersionsGet', 'cid', cid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/dashboard-versions`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get the detail information of the specified timerange in cluster
         * @summary get the detail information of the specified timerange in cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [startTime] start time
         * @param {number} [endTime] end time
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDataGet: (xCsrfToken_1, oid_1, cid_1, startTime_1, endTime_1, limit_1, page_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, startTime_1, endTime_1, limit_1, page_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, startTime, endTime, limit, page, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidDataGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidDataGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidDataGet', 'cid', cid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/data`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get data status of the specified cluster
         * @summary get data status of the cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} startTime startTime
         * @param {number} endTime endTime
         * @param {1 | 2 | 3 | 4} dataType int enums
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDataStatusGet: (xCsrfToken_1, oid_1, cid_1, startTime_1, endTime_1, dataType_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, startTime_1, endTime_1, dataType_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, startTime, endTime, dataType, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidDataStatusGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidDataStatusGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidDataStatusGet', 'cid', cid);
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('orgsOidClustersCidDataStatusGet', 'startTime', startTime);
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('orgsOidClustersCidDataStatusGet', 'endTime', endTime);
            // verify required parameter 'dataType' is not null or undefined
            assertParamExists('orgsOidClustersCidDataStatusGet', 'dataType', dataType);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/data_status`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (dataType !== undefined) {
                localVarQueryParameter['data_type'] = dataType;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list default values of the specified cluster version
         * @summary List default value of current version
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDefaultconfGet: (xCsrfToken_1, oid_1, cid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidDefaultconfGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidDefaultconfGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidDefaultconfGet', 'cid', cid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/defaultconf`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete cluster and data
         * @summary delete cluster and data
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDelete: (xCsrfToken_1, oid_1, cid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidDelete', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidDelete', 'cid', cid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * download file
         * @summary download total package
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDownloadConfItemidGet: (xCsrfToken_1, oid_1, cid_1, itemid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, itemid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, itemid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidDownloadConfItemidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidDownloadConfItemidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidDownloadConfItemidGet', 'cid', cid);
            // verify required parameter 'itemid' is not null or undefined
            assertParamExists('orgsOidClustersCidDownloadConfItemidGet', 'itemid', itemid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/downloadConf/{itemid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"itemid"}}`, encodeURIComponent(String(itemid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * download file
         * @summary download total package
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDownloadItemidGet: (xCsrfToken_1, oid_1, cid_1, itemid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, itemid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, itemid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidDownloadItemidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidDownloadItemidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidDownloadItemidGet', 'cid', cid);
            // verify required parameter 'itemid' is not null or undefined
            assertParamExists('orgsOidClustersCidDownloadItemidGet', 'itemid', itemid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/download/{itemid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"itemid"}}`, encodeURIComponent(String(itemid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list packages of the specified cluster
         * @summary List info of the specified cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidGet: (xCsrfToken_1, oid_1, cid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidGet', 'cid', cid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * meta information of package file
         * @summary meta information of package file
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidItemidMetaGet: (xCsrfToken_1, oid_1, cid_1, itemid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, itemid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, itemid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidItemidMetaGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidItemidMetaGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidItemidMetaGet', 'cid', cid);
            // verify required parameter 'itemid' is not null or undefined
            assertParamExists('orgsOidClustersCidItemidMetaGet', 'itemid', itemid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/{itemid}/meta`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"itemid"}}`, encodeURIComponent(String(itemid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get log url
         * @summary log url
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {number} [startTime] startTime of dashboard show
         * @param {number} [endTime] endTime of dashboard show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidLogurlItemidGet: (xCsrfToken_1, oid_1, cid_1, itemid_1, startTime_1, endTime_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, itemid_1, startTime_1, endTime_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, itemid, startTime, endTime, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidLogurlItemidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidLogurlItemidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidLogurlItemidGet', 'cid', cid);
            // verify required parameter 'itemid' is not null or undefined
            assertParamExists('orgsOidClustersCidLogurlItemidGet', 'itemid', itemid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/logurl/{itemid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"itemid"}}`, encodeURIComponent(String(itemid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list overview metrics of the specified cluster
         * @summary List metric information of the specified cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidMetricsGet: (xCsrfToken_1, oid_1, cid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidMetricsGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidMetricsGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidMetricsGet', 'cid', cid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/metrics`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * update cluster information
         * @summary update cluster information
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {ClusterUpdateClusterReq} cluster cluster information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidPut: (xCsrfToken_1, oid_1, cid_1, cluster_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, cluster_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, cluster, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidPut', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidPut', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidPut', 'cid', cid);
            // verify required parameter 'cluster' is not null or undefined
            assertParamExists('orgsOidClustersCidPut', 'cluster', cluster);
            const localVarPath = `/orgs/{oid}/clusters/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cluster, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * rebuild data for the specified package
         * @summary rebuild data for the specified package
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {CommonRebuild} rebuild rebuild
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidRebuildPut: (xCsrfToken_1, oid_1, cid_1, rebuild_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, rebuild_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, rebuild, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidRebuildPut', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidRebuildPut', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidRebuildPut', 'cid', cid);
            // verify required parameter 'rebuild' is not null or undefined
            assertParamExists('orgsOidClustersCidRebuildPut', 'rebuild', rebuild);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/rebuild`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(rebuild, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get slow log list in cluster
         * @summary get slow log list
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} itemID package id
         * @param {string} cid cluster id
         * @param {number} [beginTime] start time
         * @param {number} [endTime] end time
         * @param {Array<string>} [db] db list
         * @param {number} [limit] limit
         * @param {string} [text] text
         * @param {string} [orderBy] orderBy
         * @param {boolean} [desc] desc
         * @param {Array<string>} [plans] plans
         * @param {string} [digest] digest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidSlowqueriesGet: (xCsrfToken_1, oid_1, itemID_1, cid_1, beginTime_1, endTime_1, db_1, limit_1, text_1, orderBy_1, desc_1, plans_1, digest_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, itemID_1, cid_1, beginTime_1, endTime_1, db_1, limit_1, text_1, orderBy_1, desc_1, plans_1, digest_1, ...args_1], void 0, function* (xCsrfToken, oid, itemID, cid, beginTime, endTime, db, limit, text, orderBy, desc, plans, digest, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidSlowqueriesGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidSlowqueriesGet', 'oid', oid);
            // verify required parameter 'itemID' is not null or undefined
            assertParamExists('orgsOidClustersCidSlowqueriesGet', 'itemID', itemID);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidSlowqueriesGet', 'cid', cid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/slowqueries`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (itemID !== undefined) {
                localVarQueryParameter['itemID'] = itemID;
            }
            if (beginTime !== undefined) {
                localVarQueryParameter['begin_time'] = beginTime;
            }
            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = endTime;
            }
            if (db) {
                localVarQueryParameter['db'] = db.join(COLLECTION_FORMATS.csv);
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (text !== undefined) {
                localVarQueryParameter['text'] = text;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }
            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }
            if (plans) {
                localVarQueryParameter['plans'] = plans.join(COLLECTION_FORMATS.csv);
            }
            if (digest !== undefined) {
                localVarQueryParameter['digest'] = digest;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get slow log detail in cluster
         * @summary get slow log detail
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} itemID package id
         * @param {string} cid cluster id
         * @param {string} queryid log id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidSlowqueriesQueryidGet: (xCsrfToken_1, oid_1, itemID_1, cid_1, queryid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, itemID_1, cid_1, queryid_1, ...args_1], void 0, function* (xCsrfToken, oid, itemID, cid, queryid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidSlowqueriesQueryidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidSlowqueriesQueryidGet', 'oid', oid);
            // verify required parameter 'itemID' is not null or undefined
            assertParamExists('orgsOidClustersCidSlowqueriesQueryidGet', 'itemID', itemID);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidSlowqueriesQueryidGet', 'cid', cid);
            // verify required parameter 'queryid' is not null or undefined
            assertParamExists('orgsOidClustersCidSlowqueriesQueryidGet', 'queryid', queryid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/slowqueries/{queryid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"queryid"}}`, encodeURIComponent(String(queryid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (itemID !== undefined) {
                localVarQueryParameter['itemID'] = itemID;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * update cluster status
         * @summary update cluster status
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {ClusterUpdateClusterReq} cluster cluster information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidUpdateStatusPost: (xCsrfToken_1, oid_1, cid_1, cluster_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, cluster_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, cluster, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidUpdateStatusPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidUpdateStatusPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidUpdateStatusPost', 'cid', cid);
            // verify required parameter 'cluster' is not null or undefined
            assertParamExists('orgsOidClustersCidUpdateStatusPost', 'cluster', cluster);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/update_status`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cluster, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list cluster of the specified organization
         * @summary List clusters
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} [limit] the count per page
         * @param {string} [query] the query of cluster
         * @param {number} [page] the page index
         * @param {string} [pid] project id
         * @param {boolean} [showDeleted] show deleted cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersGet: (xCsrfToken_1, oid_1, limit_1, query_1, page_1, pid_1, showDeleted_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, limit_1, query_1, page_1, pid_1, showDeleted_1, ...args_1], void 0, function* (xCsrfToken, oid, limit, query, page, pid, showDeleted, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersGet', 'oid', oid);
            const localVarPath = `/orgs/{oid}/clusters`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pid !== undefined) {
                localVarQueryParameter['pid'] = pid;
            }
            if (showDeleted !== undefined) {
                localVarQueryParameter['show_deleted'] = showDeleted;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * add a cluster
         * @summary Add cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersPost: (xCsrfToken_1, oid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, ...args_1], void 0, function* (xCsrfToken, oid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersPost', 'oid', oid);
            const localVarPath = `/orgs/{oid}/clusters`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ClusterApi - functional programming interface
 * @export
 */
export const ClusterApiFp = function (configuration) {
    const localVarAxiosParamCreator = ClusterApiAxiosParamCreator(configuration);
    return {
        /**
         * Get cluster basic information by cluster id (lightweight direct DB lookup)
         * @summary Get cluster basic info by ID
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersCidGet(xCsrfToken, oid, cid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clustersCidGet(xCsrfToken, oid, cid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list dashboard user can access
         * @summary list dashboard user can access
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [startTime] startTime of dashboard show
         * @param {number} [endTime] endTime of dashboard show
         * @param {string} [version] tidb version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDashboardGet(xCsrfToken, oid, cid, startTime, endTime, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidDashboardGet(xCsrfToken, oid, cid, startTime, endTime, version, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list available dashboard version
         * @summary list available dashboard version
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDashboardVersionsGet(xCsrfToken, oid, cid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidDashboardVersionsGet(xCsrfToken, oid, cid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get the detail information of the specified timerange in cluster
         * @summary get the detail information of the specified timerange in cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [startTime] start time
         * @param {number} [endTime] end time
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDataGet(xCsrfToken, oid, cid, startTime, endTime, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidDataGet(xCsrfToken, oid, cid, startTime, endTime, limit, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get data status of the specified cluster
         * @summary get data status of the cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} startTime startTime
         * @param {number} endTime endTime
         * @param {1 | 2 | 3 | 4} dataType int enums
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDataStatusGet(xCsrfToken, oid, cid, startTime, endTime, dataType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidDataStatusGet(xCsrfToken, oid, cid, startTime, endTime, dataType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list default values of the specified cluster version
         * @summary List default value of current version
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDefaultconfGet(xCsrfToken, oid, cid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidDefaultconfGet(xCsrfToken, oid, cid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * delete cluster and data
         * @summary delete cluster and data
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDelete(xCsrfToken, oid, cid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidDelete(xCsrfToken, oid, cid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * download file
         * @summary download total package
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDownloadConfItemidGet(xCsrfToken, oid, cid, itemid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidDownloadConfItemidGet(xCsrfToken, oid, cid, itemid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * download file
         * @summary download total package
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDownloadItemidGet(xCsrfToken, oid, cid, itemid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidDownloadItemidGet(xCsrfToken, oid, cid, itemid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list packages of the specified cluster
         * @summary List info of the specified cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidGet(xCsrfToken, oid, cid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidGet(xCsrfToken, oid, cid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * meta information of package file
         * @summary meta information of package file
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidItemidMetaGet(xCsrfToken, oid, cid, itemid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidItemidMetaGet(xCsrfToken, oid, cid, itemid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get log url
         * @summary log url
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {number} [startTime] startTime of dashboard show
         * @param {number} [endTime] endTime of dashboard show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidLogurlItemidGet(xCsrfToken, oid, cid, itemid, startTime, endTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidLogurlItemidGet(xCsrfToken, oid, cid, itemid, startTime, endTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list overview metrics of the specified cluster
         * @summary List metric information of the specified cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidMetricsGet(xCsrfToken, oid, cid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidMetricsGet(xCsrfToken, oid, cid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * update cluster information
         * @summary update cluster information
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {ClusterUpdateClusterReq} cluster cluster information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidPut(xCsrfToken, oid, cid, cluster, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidPut(xCsrfToken, oid, cid, cluster, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * rebuild data for the specified package
         * @summary rebuild data for the specified package
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {CommonRebuild} rebuild rebuild
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidRebuildPut(xCsrfToken, oid, cid, rebuild, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidRebuildPut(xCsrfToken, oid, cid, rebuild, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get slow log list in cluster
         * @summary get slow log list
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} itemID package id
         * @param {string} cid cluster id
         * @param {number} [beginTime] start time
         * @param {number} [endTime] end time
         * @param {Array<string>} [db] db list
         * @param {number} [limit] limit
         * @param {string} [text] text
         * @param {string} [orderBy] orderBy
         * @param {boolean} [desc] desc
         * @param {Array<string>} [plans] plans
         * @param {string} [digest] digest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidSlowqueriesGet(xCsrfToken, oid, itemID, cid, beginTime, endTime, db, limit, text, orderBy, desc, plans, digest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidSlowqueriesGet(xCsrfToken, oid, itemID, cid, beginTime, endTime, db, limit, text, orderBy, desc, plans, digest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get slow log detail in cluster
         * @summary get slow log detail
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} itemID package id
         * @param {string} cid cluster id
         * @param {string} queryid log id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidSlowqueriesQueryidGet(xCsrfToken, oid, itemID, cid, queryid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidSlowqueriesQueryidGet(xCsrfToken, oid, itemID, cid, queryid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * update cluster status
         * @summary update cluster status
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {ClusterUpdateClusterReq} cluster cluster information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidUpdateStatusPost(xCsrfToken, oid, cid, cluster, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidUpdateStatusPost(xCsrfToken, oid, cid, cluster, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list cluster of the specified organization
         * @summary List clusters
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} [limit] the count per page
         * @param {string} [query] the query of cluster
         * @param {number} [page] the page index
         * @param {string} [pid] project id
         * @param {boolean} [showDeleted] show deleted cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersGet(xCsrfToken, oid, limit, query, page, pid, showDeleted, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersGet(xCsrfToken, oid, limit, query, page, pid, showDeleted, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * add a cluster
         * @summary Add cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersPost(xCsrfToken, oid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersPost(xCsrfToken, oid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ClusterApi - factory interface
 * @export
 */
export const ClusterApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ClusterApiFp(configuration);
    return {
        /**
         * Get cluster basic information by cluster id (lightweight direct DB lookup)
         * @summary Get cluster basic info by ID
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clustersCidGet(xCsrfToken, oid, cid, options) {
            return localVarFp.clustersCidGet(xCsrfToken, oid, cid, options).then((request) => request(axios, basePath));
        },
        /**
         * list dashboard user can access
         * @summary list dashboard user can access
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [startTime] startTime of dashboard show
         * @param {number} [endTime] endTime of dashboard show
         * @param {string} [version] tidb version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDashboardGet(xCsrfToken, oid, cid, startTime, endTime, version, options) {
            return localVarFp.orgsOidClustersCidDashboardGet(xCsrfToken, oid, cid, startTime, endTime, version, options).then((request) => request(axios, basePath));
        },
        /**
         * list available dashboard version
         * @summary list available dashboard version
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDashboardVersionsGet(xCsrfToken, oid, cid, options) {
            return localVarFp.orgsOidClustersCidDashboardVersionsGet(xCsrfToken, oid, cid, options).then((request) => request(axios, basePath));
        },
        /**
         * get the detail information of the specified timerange in cluster
         * @summary get the detail information of the specified timerange in cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [startTime] start time
         * @param {number} [endTime] end time
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDataGet(xCsrfToken, oid, cid, startTime, endTime, limit, page, options) {
            return localVarFp.orgsOidClustersCidDataGet(xCsrfToken, oid, cid, startTime, endTime, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * get data status of the specified cluster
         * @summary get data status of the cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} startTime startTime
         * @param {number} endTime endTime
         * @param {1 | 2 | 3 | 4} dataType int enums
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDataStatusGet(xCsrfToken, oid, cid, startTime, endTime, dataType, options) {
            return localVarFp.orgsOidClustersCidDataStatusGet(xCsrfToken, oid, cid, startTime, endTime, dataType, options).then((request) => request(axios, basePath));
        },
        /**
         * list default values of the specified cluster version
         * @summary List default value of current version
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDefaultconfGet(xCsrfToken, oid, cid, options) {
            return localVarFp.orgsOidClustersCidDefaultconfGet(xCsrfToken, oid, cid, options).then((request) => request(axios, basePath));
        },
        /**
         * delete cluster and data
         * @summary delete cluster and data
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDelete(xCsrfToken, oid, cid, options) {
            return localVarFp.orgsOidClustersCidDelete(xCsrfToken, oid, cid, options).then((request) => request(axios, basePath));
        },
        /**
         * download file
         * @summary download total package
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDownloadConfItemidGet(xCsrfToken, oid, cid, itemid, options) {
            return localVarFp.orgsOidClustersCidDownloadConfItemidGet(xCsrfToken, oid, cid, itemid, options).then((request) => request(axios, basePath));
        },
        /**
         * download file
         * @summary download total package
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidDownloadItemidGet(xCsrfToken, oid, cid, itemid, options) {
            return localVarFp.orgsOidClustersCidDownloadItemidGet(xCsrfToken, oid, cid, itemid, options).then((request) => request(axios, basePath));
        },
        /**
         * list packages of the specified cluster
         * @summary List info of the specified cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidGet(xCsrfToken, oid, cid, options) {
            return localVarFp.orgsOidClustersCidGet(xCsrfToken, oid, cid, options).then((request) => request(axios, basePath));
        },
        /**
         * meta information of package file
         * @summary meta information of package file
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidItemidMetaGet(xCsrfToken, oid, cid, itemid, options) {
            return localVarFp.orgsOidClustersCidItemidMetaGet(xCsrfToken, oid, cid, itemid, options).then((request) => request(axios, basePath));
        },
        /**
         * get log url
         * @summary log url
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} itemid item id
         * @param {number} [startTime] startTime of dashboard show
         * @param {number} [endTime] endTime of dashboard show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidLogurlItemidGet(xCsrfToken, oid, cid, itemid, startTime, endTime, options) {
            return localVarFp.orgsOidClustersCidLogurlItemidGet(xCsrfToken, oid, cid, itemid, startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * list overview metrics of the specified cluster
         * @summary List metric information of the specified cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidMetricsGet(xCsrfToken, oid, cid, options) {
            return localVarFp.orgsOidClustersCidMetricsGet(xCsrfToken, oid, cid, options).then((request) => request(axios, basePath));
        },
        /**
         * update cluster information
         * @summary update cluster information
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {ClusterUpdateClusterReq} cluster cluster information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidPut(xCsrfToken, oid, cid, cluster, options) {
            return localVarFp.orgsOidClustersCidPut(xCsrfToken, oid, cid, cluster, options).then((request) => request(axios, basePath));
        },
        /**
         * rebuild data for the specified package
         * @summary rebuild data for the specified package
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {CommonRebuild} rebuild rebuild
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidRebuildPut(xCsrfToken, oid, cid, rebuild, options) {
            return localVarFp.orgsOidClustersCidRebuildPut(xCsrfToken, oid, cid, rebuild, options).then((request) => request(axios, basePath));
        },
        /**
         * get slow log list in cluster
         * @summary get slow log list
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} itemID package id
         * @param {string} cid cluster id
         * @param {number} [beginTime] start time
         * @param {number} [endTime] end time
         * @param {Array<string>} [db] db list
         * @param {number} [limit] limit
         * @param {string} [text] text
         * @param {string} [orderBy] orderBy
         * @param {boolean} [desc] desc
         * @param {Array<string>} [plans] plans
         * @param {string} [digest] digest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidSlowqueriesGet(xCsrfToken, oid, itemID, cid, beginTime, endTime, db, limit, text, orderBy, desc, plans, digest, options) {
            return localVarFp.orgsOidClustersCidSlowqueriesGet(xCsrfToken, oid, itemID, cid, beginTime, endTime, db, limit, text, orderBy, desc, plans, digest, options).then((request) => request(axios, basePath));
        },
        /**
         * get slow log detail in cluster
         * @summary get slow log detail
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} itemID package id
         * @param {string} cid cluster id
         * @param {string} queryid log id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidSlowqueriesQueryidGet(xCsrfToken, oid, itemID, cid, queryid, options) {
            return localVarFp.orgsOidClustersCidSlowqueriesQueryidGet(xCsrfToken, oid, itemID, cid, queryid, options).then((request) => request(axios, basePath));
        },
        /**
         * update cluster status
         * @summary update cluster status
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {ClusterUpdateClusterReq} cluster cluster information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidUpdateStatusPost(xCsrfToken, oid, cid, cluster, options) {
            return localVarFp.orgsOidClustersCidUpdateStatusPost(xCsrfToken, oid, cid, cluster, options).then((request) => request(axios, basePath));
        },
        /**
         * list cluster of the specified organization
         * @summary List clusters
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} [limit] the count per page
         * @param {string} [query] the query of cluster
         * @param {number} [page] the page index
         * @param {string} [pid] project id
         * @param {boolean} [showDeleted] show deleted cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersGet(xCsrfToken, oid, limit, query, page, pid, showDeleted, options) {
            return localVarFp.orgsOidClustersGet(xCsrfToken, oid, limit, query, page, pid, showDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * add a cluster
         * @summary Add cluster
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersPost(xCsrfToken, oid, options) {
            return localVarFp.orgsOidClustersPost(xCsrfToken, oid, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ClusterApi - object-oriented interface
 * @export
 * @class ClusterApi
 * @extends {BaseAPI}
 */
export class ClusterApi extends BaseAPI {
    /**
     * Get cluster basic information by cluster id (lightweight direct DB lookup)
     * @summary Get cluster basic info by ID
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    clustersCidGet(xCsrfToken, oid, cid, options) {
        return ClusterApiFp(this.configuration).clustersCidGet(xCsrfToken, oid, cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list dashboard user can access
     * @summary list dashboard user can access
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {number} [startTime] startTime of dashboard show
     * @param {number} [endTime] endTime of dashboard show
     * @param {string} [version] tidb version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidDashboardGet(xCsrfToken, oid, cid, startTime, endTime, version, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidDashboardGet(xCsrfToken, oid, cid, startTime, endTime, version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list available dashboard version
     * @summary list available dashboard version
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidDashboardVersionsGet(xCsrfToken, oid, cid, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidDashboardVersionsGet(xCsrfToken, oid, cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get the detail information of the specified timerange in cluster
     * @summary get the detail information of the specified timerange in cluster
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {number} [startTime] start time
     * @param {number} [endTime] end time
     * @param {number} [limit] the count per page
     * @param {number} [page] the page index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidDataGet(xCsrfToken, oid, cid, startTime, endTime, limit, page, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidDataGet(xCsrfToken, oid, cid, startTime, endTime, limit, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get data status of the specified cluster
     * @summary get data status of the cluster
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {number} startTime startTime
     * @param {number} endTime endTime
     * @param {1 | 2 | 3 | 4} dataType int enums
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidDataStatusGet(xCsrfToken, oid, cid, startTime, endTime, dataType, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidDataStatusGet(xCsrfToken, oid, cid, startTime, endTime, dataType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list default values of the specified cluster version
     * @summary List default value of current version
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidDefaultconfGet(xCsrfToken, oid, cid, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidDefaultconfGet(xCsrfToken, oid, cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete cluster and data
     * @summary delete cluster and data
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidDelete(xCsrfToken, oid, cid, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidDelete(xCsrfToken, oid, cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * download file
     * @summary download total package
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} itemid item id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidDownloadConfItemidGet(xCsrfToken, oid, cid, itemid, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidDownloadConfItemidGet(xCsrfToken, oid, cid, itemid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * download file
     * @summary download total package
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} itemid item id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidDownloadItemidGet(xCsrfToken, oid, cid, itemid, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidDownloadItemidGet(xCsrfToken, oid, cid, itemid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list packages of the specified cluster
     * @summary List info of the specified cluster
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidGet(xCsrfToken, oid, cid, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidGet(xCsrfToken, oid, cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * meta information of package file
     * @summary meta information of package file
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} itemid item id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidItemidMetaGet(xCsrfToken, oid, cid, itemid, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidItemidMetaGet(xCsrfToken, oid, cid, itemid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get log url
     * @summary log url
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} itemid item id
     * @param {number} [startTime] startTime of dashboard show
     * @param {number} [endTime] endTime of dashboard show
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidLogurlItemidGet(xCsrfToken, oid, cid, itemid, startTime, endTime, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidLogurlItemidGet(xCsrfToken, oid, cid, itemid, startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list overview metrics of the specified cluster
     * @summary List metric information of the specified cluster
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidMetricsGet(xCsrfToken, oid, cid, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidMetricsGet(xCsrfToken, oid, cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * update cluster information
     * @summary update cluster information
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {ClusterUpdateClusterReq} cluster cluster information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidPut(xCsrfToken, oid, cid, cluster, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidPut(xCsrfToken, oid, cid, cluster, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * rebuild data for the specified package
     * @summary rebuild data for the specified package
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {CommonRebuild} rebuild rebuild
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidRebuildPut(xCsrfToken, oid, cid, rebuild, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidRebuildPut(xCsrfToken, oid, cid, rebuild, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get slow log list in cluster
     * @summary get slow log list
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} itemID package id
     * @param {string} cid cluster id
     * @param {number} [beginTime] start time
     * @param {number} [endTime] end time
     * @param {Array<string>} [db] db list
     * @param {number} [limit] limit
     * @param {string} [text] text
     * @param {string} [orderBy] orderBy
     * @param {boolean} [desc] desc
     * @param {Array<string>} [plans] plans
     * @param {string} [digest] digest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidSlowqueriesGet(xCsrfToken, oid, itemID, cid, beginTime, endTime, db, limit, text, orderBy, desc, plans, digest, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidSlowqueriesGet(xCsrfToken, oid, itemID, cid, beginTime, endTime, db, limit, text, orderBy, desc, plans, digest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get slow log detail in cluster
     * @summary get slow log detail
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} itemID package id
     * @param {string} cid cluster id
     * @param {string} queryid log id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidSlowqueriesQueryidGet(xCsrfToken, oid, itemID, cid, queryid, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidSlowqueriesQueryidGet(xCsrfToken, oid, itemID, cid, queryid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * update cluster status
     * @summary update cluster status
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {ClusterUpdateClusterReq} cluster cluster information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersCidUpdateStatusPost(xCsrfToken, oid, cid, cluster, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersCidUpdateStatusPost(xCsrfToken, oid, cid, cluster, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list cluster of the specified organization
     * @summary List clusters
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {number} [limit] the count per page
     * @param {string} [query] the query of cluster
     * @param {number} [page] the page index
     * @param {string} [pid] project id
     * @param {boolean} [showDeleted] show deleted cluster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersGet(xCsrfToken, oid, limit, query, page, pid, showDeleted, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersGet(xCsrfToken, oid, limit, query, page, pid, showDeleted, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * add a cluster
     * @summary Add cluster
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    orgsOidClustersPost(xCsrfToken, oid, options) {
        return ClusterApiFp(this.configuration).orgsOidClustersPost(xCsrfToken, oid, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ClusterSloganApi - axios parameter creator
 * @export
 */
export const ClusterSloganApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * get cluster slogan
         * @summary get cluster slogan
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidSlogansGet: (xCsrfToken_1, oid_1, cid_1, limit_1, page_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, limit_1, page_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, limit, page, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidSlogansGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidSlogansGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidSlogansGet', 'cid', cid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/slogans`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ClusterSloganApi - functional programming interface
 * @export
 */
export const ClusterSloganApiFp = function (configuration) {
    const localVarAxiosParamCreator = ClusterSloganApiAxiosParamCreator(configuration);
    return {
        /**
         * get cluster slogan
         * @summary get cluster slogan
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidSlogansGet(xCsrfToken, oid, cid, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidSlogansGet(xCsrfToken, oid, cid, limit, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ClusterSloganApi - factory interface
 * @export
 */
export const ClusterSloganApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ClusterSloganApiFp(configuration);
    return {
        /**
         * get cluster slogan
         * @summary get cluster slogan
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidSlogansGet(xCsrfToken, oid, cid, limit, page, options) {
            return localVarFp.orgsOidClustersCidSlogansGet(xCsrfToken, oid, cid, limit, page, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ClusterSloganApi - object-oriented interface
 * @export
 * @class ClusterSloganApi
 * @extends {BaseAPI}
 */
export class ClusterSloganApi extends BaseAPI {
    /**
     * get cluster slogan
     * @summary get cluster slogan
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {number} [limit] the count per page
     * @param {number} [page] the page index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterSloganApi
     */
    orgsOidClustersCidSlogansGet(xCsrfToken, oid, cid, limit, page, options) {
        return ClusterSloganApiFp(this.configuration).orgsOidClustersCidSlogansGet(xCsrfToken, oid, cid, limit, page, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * get activity
         * @summary get activity
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {string} activityId activity id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitiesActivityIdGet: (applicationId_1, targetId_1, activityId_1, ...args_1) => __awaiter(this, [applicationId_1, targetId_1, activityId_1, ...args_1], void 0, function* (applicationId, targetId, activityId, options = {}) {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitiesActivityIdGet', 'applicationId', applicationId);
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitiesActivityIdGet', 'targetId', targetId);
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitiesActivityIdGet', 'activityId', activityId);
            const localVarPath = `/activityhub/applications/{application_id}/targets/{target_id}/activities/{activity_id}`
                .replace(`{${"application_id"}}`, encodeURIComponent(String(applicationId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)))
                .replace(`{${"activity_id"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list activities
         * @summary list activities
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {number} beginTs begin_ts
         * @param {number} endTs end_ts
         * @param {string} [catalog] catalog
         * @param {string} [type] type
         * @param {string} [name] name
         * @param {number} [severity] severity
         * @param {number} [limit] limit
         * @param {string} [cursor] coursor for page limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet: (applicationId_1, targetId_1, beginTs_1, endTs_1, catalog_1, type_1, name_1, severity_1, limit_1, cursor_1, ...args_1) => __awaiter(this, [applicationId_1, targetId_1, beginTs_1, endTs_1, catalog_1, type_1, name_1, severity_1, limit_1, cursor_1, ...args_1], void 0, function* (applicationId, targetId, beginTs, endTs, catalog, type, name, severity, limit, cursor, options = {}) {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet', 'applicationId', applicationId);
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet', 'targetId', targetId);
            // verify required parameter 'beginTs' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet', 'beginTs', beginTs);
            // verify required parameter 'endTs' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet', 'endTs', endTs);
            const localVarPath = `/activityhub/applications/{application_id}/targets/{target_id}/activities`
                .replace(`{${"application_id"}}`, encodeURIComponent(String(applicationId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (beginTs !== undefined) {
                localVarQueryParameter['begin_ts'] = beginTs;
            }
            if (endTs !== undefined) {
                localVarQueryParameter['end_ts'] = endTs;
            }
            if (catalog !== undefined) {
                localVarQueryParameter['catalog'] = catalog;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (cursor !== undefined && cursor !== null) {
                localVarHeaderParameter['cursor'] = String(cursor);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get activitygroup
         * @summary get activitygroup
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {string} contextId context id
         * @param {string} [type] type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsContextIdGet: (applicationId_1, targetId_1, contextId_1, type_1, ...args_1) => __awaiter(this, [applicationId_1, targetId_1, contextId_1, type_1, ...args_1], void 0, function* (applicationId, targetId, contextId, type, options = {}) {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsContextIdGet', 'applicationId', applicationId);
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsContextIdGet', 'targetId', targetId);
            // verify required parameter 'contextId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsContextIdGet', 'contextId', contextId);
            const localVarPath = `/activityhub/applications/{application_id}/targets/{target_id}/activitygroups/{context_id}`
                .replace(`{${"application_id"}}`, encodeURIComponent(String(applicationId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)))
                .replace(`{${"context_id"}}`, encodeURIComponent(String(contextId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list activity groups
         * @summary list activity groups
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {number} beginTs begin_ts
         * @param {number} endTs end_ts
         * @param {number} severity severity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet: (applicationId_1, targetId_1, beginTs_1, endTs_1, severity_1, ...args_1) => __awaiter(this, [applicationId_1, targetId_1, beginTs_1, endTs_1, severity_1, ...args_1], void 0, function* (applicationId, targetId, beginTs, endTs, severity, options = {}) {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet', 'applicationId', applicationId);
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet', 'targetId', targetId);
            // verify required parameter 'beginTs' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet', 'beginTs', beginTs);
            // verify required parameter 'endTs' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet', 'endTs', endTs);
            // verify required parameter 'severity' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet', 'severity', severity);
            const localVarPath = `/activityhub/applications/{application_id}/targets/{target_id}/activitygroups`
                .replace(`{${"application_id"}}`, encodeURIComponent(String(applicationId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (beginTs !== undefined) {
                localVarQueryParameter['begin_ts'] = beginTs;
            }
            if (endTs !== undefined) {
                localVarQueryParameter['end_ts'] = endTs;
            }
            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * post gitops activity
         * @summary post gitops activity
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {string} contextId context id
         * @param {string} [type] type
         * @param {string} [summary] summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdContextsContextIdPost: (applicationId_1, targetId_1, contextId_1, type_1, summary_1, ...args_1) => __awaiter(this, [applicationId_1, targetId_1, contextId_1, type_1, summary_1, ...args_1], void 0, function* (applicationId, targetId, contextId, type, summary, options = {}) {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdContextsContextIdPost', 'applicationId', applicationId);
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdContextsContextIdPost', 'targetId', targetId);
            // verify required parameter 'contextId' is not null or undefined
            assertParamExists('activityhubApplicationsApplicationIdTargetsTargetIdContextsContextIdPost', 'contextId', contextId);
            const localVarPath = `/activityhub/applications/{application_id}/targets/{target_id}/contexts/{context_id}`
                .replace(`{${"application_id"}}`, encodeURIComponent(String(applicationId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)))
                .replace(`{${"context_id"}}`, encodeURIComponent(String(contextId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (summary !== undefined) {
                localVarQueryParameter['summary'] = summary;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * download activity file
         * @summary Download activity file
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} key object key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubFileDownloadGet: (xCsrfToken_1, key_1, ...args_1) => __awaiter(this, [xCsrfToken_1, key_1, ...args_1], void 0, function* (xCsrfToken, key, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('activityhubFileDownloadGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'key' is not null or undefined
            assertParamExists('activityhubFileDownloadGet', 'key', key);
            const localVarPath = `/activityhub/file/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * view activity file
         * @summary View activity file
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} key object key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubFileViewGet: (xCsrfToken_1, key_1, ...args_1) => __awaiter(this, [xCsrfToken_1, key_1, ...args_1], void 0, function* (xCsrfToken, key, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('activityhubFileViewGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'key' is not null or undefined
            assertParamExists('activityhubFileViewGet', 'key', key);
            const localVarPath = `/activityhub/file/view`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         * get activity
         * @summary get activity
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {string} activityId activity id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitiesActivityIdGet(applicationId, targetId, activityId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activityhubApplicationsApplicationIdTargetsTargetIdActivitiesActivityIdGet(applicationId, targetId, activityId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list activities
         * @summary list activities
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {number} beginTs begin_ts
         * @param {number} endTs end_ts
         * @param {string} [catalog] catalog
         * @param {string} [type] type
         * @param {string} [name] name
         * @param {number} [severity] severity
         * @param {number} [limit] limit
         * @param {string} [cursor] coursor for page limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet(applicationId, targetId, beginTs, endTs, catalog, type, name, severity, limit, cursor, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet(applicationId, targetId, beginTs, endTs, catalog, type, name, severity, limit, cursor, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get activitygroup
         * @summary get activitygroup
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {string} contextId context id
         * @param {string} [type] type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsContextIdGet(applicationId, targetId, contextId, type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsContextIdGet(applicationId, targetId, contextId, type, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list activity groups
         * @summary list activity groups
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {number} beginTs begin_ts
         * @param {number} endTs end_ts
         * @param {number} severity severity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet(applicationId, targetId, beginTs, endTs, severity, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet(applicationId, targetId, beginTs, endTs, severity, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * post gitops activity
         * @summary post gitops activity
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {string} contextId context id
         * @param {string} [type] type
         * @param {string} [summary] summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdContextsContextIdPost(applicationId, targetId, contextId, type, summary, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activityhubApplicationsApplicationIdTargetsTargetIdContextsContextIdPost(applicationId, targetId, contextId, type, summary, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * download activity file
         * @summary Download activity file
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} key object key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubFileDownloadGet(xCsrfToken, key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activityhubFileDownloadGet(xCsrfToken, key, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * view activity file
         * @summary View activity file
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} key object key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubFileViewGet(xCsrfToken, key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activityhubFileViewGet(xCsrfToken, key, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DefaultApiFp(configuration);
    return {
        /**
         * get activity
         * @summary get activity
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {string} activityId activity id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitiesActivityIdGet(applicationId, targetId, activityId, options) {
            return localVarFp.activityhubApplicationsApplicationIdTargetsTargetIdActivitiesActivityIdGet(applicationId, targetId, activityId, options).then((request) => request(axios, basePath));
        },
        /**
         * list activities
         * @summary list activities
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {number} beginTs begin_ts
         * @param {number} endTs end_ts
         * @param {string} [catalog] catalog
         * @param {string} [type] type
         * @param {string} [name] name
         * @param {number} [severity] severity
         * @param {number} [limit] limit
         * @param {string} [cursor] coursor for page limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet(applicationId, targetId, beginTs, endTs, catalog, type, name, severity, limit, cursor, options) {
            return localVarFp.activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet(applicationId, targetId, beginTs, endTs, catalog, type, name, severity, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * get activitygroup
         * @summary get activitygroup
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {string} contextId context id
         * @param {string} [type] type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsContextIdGet(applicationId, targetId, contextId, type, options) {
            return localVarFp.activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsContextIdGet(applicationId, targetId, contextId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * list activity groups
         * @summary list activity groups
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {number} beginTs begin_ts
         * @param {number} endTs end_ts
         * @param {number} severity severity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet(applicationId, targetId, beginTs, endTs, severity, options) {
            return localVarFp.activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet(applicationId, targetId, beginTs, endTs, severity, options).then((request) => request(axios, basePath));
        },
        /**
         * post gitops activity
         * @summary post gitops activity
         * @param {string} applicationId application_id
         * @param {string} targetId target_id
         * @param {string} contextId context id
         * @param {string} [type] type
         * @param {string} [summary] summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubApplicationsApplicationIdTargetsTargetIdContextsContextIdPost(applicationId, targetId, contextId, type, summary, options) {
            return localVarFp.activityhubApplicationsApplicationIdTargetsTargetIdContextsContextIdPost(applicationId, targetId, contextId, type, summary, options).then((request) => request(axios, basePath));
        },
        /**
         * download activity file
         * @summary Download activity file
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} key object key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubFileDownloadGet(xCsrfToken, key, options) {
            return localVarFp.activityhubFileDownloadGet(xCsrfToken, key, options).then((request) => request(axios, basePath));
        },
        /**
         * view activity file
         * @summary View activity file
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} key object key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activityhubFileViewGet(xCsrfToken, key, options) {
            return localVarFp.activityhubFileViewGet(xCsrfToken, key, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * get activity
     * @summary get activity
     * @param {string} applicationId application_id
     * @param {string} targetId target_id
     * @param {string} activityId activity id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    activityhubApplicationsApplicationIdTargetsTargetIdActivitiesActivityIdGet(applicationId, targetId, activityId, options) {
        return DefaultApiFp(this.configuration).activityhubApplicationsApplicationIdTargetsTargetIdActivitiesActivityIdGet(applicationId, targetId, activityId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list activities
     * @summary list activities
     * @param {string} applicationId application_id
     * @param {string} targetId target_id
     * @param {number} beginTs begin_ts
     * @param {number} endTs end_ts
     * @param {string} [catalog] catalog
     * @param {string} [type] type
     * @param {string} [name] name
     * @param {number} [severity] severity
     * @param {number} [limit] limit
     * @param {string} [cursor] coursor for page limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet(applicationId, targetId, beginTs, endTs, catalog, type, name, severity, limit, cursor, options) {
        return DefaultApiFp(this.configuration).activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet(applicationId, targetId, beginTs, endTs, catalog, type, name, severity, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get activitygroup
     * @summary get activitygroup
     * @param {string} applicationId application_id
     * @param {string} targetId target_id
     * @param {string} contextId context id
     * @param {string} [type] type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsContextIdGet(applicationId, targetId, contextId, type, options) {
        return DefaultApiFp(this.configuration).activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsContextIdGet(applicationId, targetId, contextId, type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list activity groups
     * @summary list activity groups
     * @param {string} applicationId application_id
     * @param {string} targetId target_id
     * @param {number} beginTs begin_ts
     * @param {number} endTs end_ts
     * @param {number} severity severity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet(applicationId, targetId, beginTs, endTs, severity, options) {
        return DefaultApiFp(this.configuration).activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet(applicationId, targetId, beginTs, endTs, severity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * post gitops activity
     * @summary post gitops activity
     * @param {string} applicationId application_id
     * @param {string} targetId target_id
     * @param {string} contextId context id
     * @param {string} [type] type
     * @param {string} [summary] summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    activityhubApplicationsApplicationIdTargetsTargetIdContextsContextIdPost(applicationId, targetId, contextId, type, summary, options) {
        return DefaultApiFp(this.configuration).activityhubApplicationsApplicationIdTargetsTargetIdContextsContextIdPost(applicationId, targetId, contextId, type, summary, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * download activity file
     * @summary Download activity file
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} key object key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    activityhubFileDownloadGet(xCsrfToken, key, options) {
        return DefaultApiFp(this.configuration).activityhubFileDownloadGet(xCsrfToken, key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * view activity file
     * @summary View activity file
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} key object key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    activityhubFileViewGet(xCsrfToken, key, options) {
        return DefaultApiFp(this.configuration).activityhubFileViewGet(xCsrfToken, key, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GlobalDashboardApi - axios parameter creator
 * @export
 */
export const GlobalDashboardApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * list cloud clusters QPS status
         * @summary list cloud clusters QPS status
         * @param {string} threshold threshold
         * @param {number} beginTs begin_ts
         * @param {number} endTs end_ts
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [search] search tenant name/id or cluster name/id
         * @param {Array<string>} [region] cluster region filter
         * @param {Array<string>} [deployType] deploy type filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardActiveqpsGet: (threshold_1, beginTs_1, endTs_1, xCsrfToken_1, search_1, region_1, deployType_1, ...args_1) => __awaiter(this, [threshold_1, beginTs_1, endTs_1, xCsrfToken_1, search_1, region_1, deployType_1, ...args_1], void 0, function* (threshold, beginTs, endTs, xCsrfToken, search, region, deployType, options = {}) {
            // verify required parameter 'threshold' is not null or undefined
            assertParamExists('dashboardActiveqpsGet', 'threshold', threshold);
            // verify required parameter 'beginTs' is not null or undefined
            assertParamExists('dashboardActiveqpsGet', 'beginTs', beginTs);
            // verify required parameter 'endTs' is not null or undefined
            assertParamExists('dashboardActiveqpsGet', 'endTs', endTs);
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('dashboardActiveqpsGet', 'xCsrfToken', xCsrfToken);
            const localVarPath = `/dashboard/activeqps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (threshold !== undefined) {
                localVarQueryParameter['threshold'] = threshold;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (region) {
                localVarQueryParameter['region'] = region;
            }
            if (deployType) {
                localVarQueryParameter['deploy_type'] = deployType;
            }
            if (beginTs !== undefined) {
                localVarQueryParameter['begin_ts'] = beginTs;
            }
            if (endTs !== undefined) {
                localVarQueryParameter['end_ts'] = endTs;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list cloud clusters status form local db
         * @summary list cloud clusters status form local db
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [query] search data from tenant id, tenant name, cluster id and cluster name
         * @param {Array<string>} [clusterId] cluster id
         * @param {Array<string>} [clusterStatus] cluster status
         * @param {Array<string>} [clusterVersion] cluster version
         * @param {Array<string>} [deployType] deploy type
         * @param {Array<string>} [deployTypeV2] deploy type v2
         * @param {Array<string>} [tenantPlan] tenant plan
         * @param {boolean} [showDeleted] show deleted cluster
         * @param {Array<string>} [controlPlane] control plane
         * @param {Array<string>} [provider] cloud provider
         * @param {Array<string>} [region] cloud region
         * @param {number} [createdTsFrom] created_at timestamp from
         * @param {number} [createdTsTo] created_at timestamp to
         * @param {number} [deletedTsFrom] deleted_at timestamp from
         * @param {number} [deletedTsTo] deleted_at timestamp to
         * @param {string} [sort] sort
         * @param {string} [order] order
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardClusters2Get: (xCsrfToken_1, query_1, clusterId_1, clusterStatus_1, clusterVersion_1, deployType_1, deployTypeV2_1, tenantPlan_1, showDeleted_1, controlPlane_1, provider_1, region_1, createdTsFrom_1, createdTsTo_1, deletedTsFrom_1, deletedTsTo_1, sort_1, order_1, limit_1, page_1, ...args_1) => __awaiter(this, [xCsrfToken_1, query_1, clusterId_1, clusterStatus_1, clusterVersion_1, deployType_1, deployTypeV2_1, tenantPlan_1, showDeleted_1, controlPlane_1, provider_1, region_1, createdTsFrom_1, createdTsTo_1, deletedTsFrom_1, deletedTsTo_1, sort_1, order_1, limit_1, page_1, ...args_1], void 0, function* (xCsrfToken, query, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, showDeleted, controlPlane, provider, region, createdTsFrom, createdTsTo, deletedTsFrom, deletedTsTo, sort, order, limit, page, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('dashboardClusters2Get', 'xCsrfToken', xCsrfToken);
            const localVarPath = `/dashboard/clusters2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (clusterId) {
                localVarQueryParameter['cluster_id'] = clusterId;
            }
            if (clusterStatus) {
                localVarQueryParameter['cluster_status'] = clusterStatus;
            }
            if (clusterVersion) {
                localVarQueryParameter['cluster_version'] = clusterVersion;
            }
            if (deployType) {
                localVarQueryParameter['deploy_type'] = deployType;
            }
            if (deployTypeV2) {
                localVarQueryParameter['deploy_type_v2'] = deployTypeV2;
            }
            if (tenantPlan) {
                localVarQueryParameter['tenant_plan'] = tenantPlan;
            }
            if (showDeleted !== undefined) {
                localVarQueryParameter['show_deleted'] = showDeleted;
            }
            if (controlPlane) {
                localVarQueryParameter['control_plane'] = controlPlane;
            }
            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }
            if (region) {
                localVarQueryParameter['region'] = region;
            }
            if (createdTsFrom !== undefined) {
                localVarQueryParameter['created_ts_from'] = createdTsFrom;
            }
            if (createdTsTo !== undefined) {
                localVarQueryParameter['created_ts_to'] = createdTsTo;
            }
            if (deletedTsFrom !== undefined) {
                localVarQueryParameter['deleted_ts_from'] = deletedTsFrom;
            }
            if (deletedTsTo !== undefined) {
                localVarQueryParameter['deleted_ts_to'] = deletedTsTo;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list cloud clusters status
         * @summary list cloud clusters status
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [query] search data from tenant id, tenant name, cluster id and cluster name
         * @param {boolean} [showDeleted] show deleted cluster
         * @param {Array<string>} [clusterId] cluster id
         * @param {Array<string>} [clusterStatus] cluster status
         * @param {Array<string>} [clusterVersion] cluster version
         * @param {Array<string>} [deployType] deploy type
         * @param {Array<string>} [deployTypeV2] deploy type v2
         * @param {Array<string>} [tenantPlan] tenant plan
         * @param {Array<string>} [controlPlane] control plane
         * @param {Array<string>} [provider] cloud provider
         * @param {Array<string>} [region] cloud region
         * @param {string} [sort] sort
         * @param {string} [order] order
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardClustersGet: (xCsrfToken_1, query_1, showDeleted_1, clusterId_1, clusterStatus_1, clusterVersion_1, deployType_1, deployTypeV2_1, tenantPlan_1, controlPlane_1, provider_1, region_1, sort_1, order_1, limit_1, page_1, ...args_1) => __awaiter(this, [xCsrfToken_1, query_1, showDeleted_1, clusterId_1, clusterStatus_1, clusterVersion_1, deployType_1, deployTypeV2_1, tenantPlan_1, controlPlane_1, provider_1, region_1, sort_1, order_1, limit_1, page_1, ...args_1], void 0, function* (xCsrfToken, query, showDeleted, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, controlPlane, provider, region, sort, order, limit, page, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('dashboardClustersGet', 'xCsrfToken', xCsrfToken);
            const localVarPath = `/dashboard/clusters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (showDeleted !== undefined) {
                localVarQueryParameter['show_deleted'] = showDeleted;
            }
            if (clusterId) {
                localVarQueryParameter['cluster_id'] = clusterId;
            }
            if (clusterStatus) {
                localVarQueryParameter['cluster_status'] = clusterStatus;
            }
            if (clusterVersion) {
                localVarQueryParameter['cluster_version'] = clusterVersion;
            }
            if (deployType) {
                localVarQueryParameter['deploy_type'] = deployType;
            }
            if (deployTypeV2) {
                localVarQueryParameter['deploy_type_v2'] = deployTypeV2;
            }
            if (tenantPlan) {
                localVarQueryParameter['tenant_plan'] = tenantPlan;
            }
            if (controlPlane) {
                localVarQueryParameter['control_plane'] = controlPlane;
            }
            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }
            if (region) {
                localVarQueryParameter['region'] = region;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * proxy dashboard
         * @summary proxy dashboard
         * @param {string} host the proxy host
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardProxyGet: (host_1, xCsrfToken_1, ...args_1) => __awaiter(this, [host_1, xCsrfToken_1, ...args_1], void 0, function* (host, xCsrfToken, options = {}) {
            // verify required parameter 'host' is not null or undefined
            assertParamExists('dashboardProxyGet', 'host', host);
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('dashboardProxyGet', 'xCsrfToken', xCsrfToken);
            const localVarPath = `/dashboard/proxy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (host !== undefined) {
                localVarQueryParameter['host'] = host;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list regions
         * @summary list regions
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {Array<string>} [provider] cloud provdier, default for all providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardRegionsGet: (xCsrfToken_1, provider_1, ...args_1) => __awaiter(this, [xCsrfToken_1, provider_1, ...args_1], void 0, function* (xCsrfToken, provider, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('dashboardRegionsGet', 'xCsrfToken', xCsrfToken);
            const localVarPath = `/dashboard/regions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (provider) {
                localVarQueryParameter['provider'] = provider.join(COLLECTION_FORMATS.csv);
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * GlobalDashboardApi - functional programming interface
 * @export
 */
export const GlobalDashboardApiFp = function (configuration) {
    const localVarAxiosParamCreator = GlobalDashboardApiAxiosParamCreator(configuration);
    return {
        /**
         * list cloud clusters QPS status
         * @summary list cloud clusters QPS status
         * @param {string} threshold threshold
         * @param {number} beginTs begin_ts
         * @param {number} endTs end_ts
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [search] search tenant name/id or cluster name/id
         * @param {Array<string>} [region] cluster region filter
         * @param {Array<string>} [deployType] deploy type filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardActiveqpsGet(threshold, beginTs, endTs, xCsrfToken, search, region, deployType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dashboardActiveqpsGet(threshold, beginTs, endTs, xCsrfToken, search, region, deployType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list cloud clusters status form local db
         * @summary list cloud clusters status form local db
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [query] search data from tenant id, tenant name, cluster id and cluster name
         * @param {Array<string>} [clusterId] cluster id
         * @param {Array<string>} [clusterStatus] cluster status
         * @param {Array<string>} [clusterVersion] cluster version
         * @param {Array<string>} [deployType] deploy type
         * @param {Array<string>} [deployTypeV2] deploy type v2
         * @param {Array<string>} [tenantPlan] tenant plan
         * @param {boolean} [showDeleted] show deleted cluster
         * @param {Array<string>} [controlPlane] control plane
         * @param {Array<string>} [provider] cloud provider
         * @param {Array<string>} [region] cloud region
         * @param {number} [createdTsFrom] created_at timestamp from
         * @param {number} [createdTsTo] created_at timestamp to
         * @param {number} [deletedTsFrom] deleted_at timestamp from
         * @param {number} [deletedTsTo] deleted_at timestamp to
         * @param {string} [sort] sort
         * @param {string} [order] order
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardClusters2Get(xCsrfToken, query, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, showDeleted, controlPlane, provider, region, createdTsFrom, createdTsTo, deletedTsFrom, deletedTsTo, sort, order, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dashboardClusters2Get(xCsrfToken, query, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, showDeleted, controlPlane, provider, region, createdTsFrom, createdTsTo, deletedTsFrom, deletedTsTo, sort, order, limit, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list cloud clusters status
         * @summary list cloud clusters status
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [query] search data from tenant id, tenant name, cluster id and cluster name
         * @param {boolean} [showDeleted] show deleted cluster
         * @param {Array<string>} [clusterId] cluster id
         * @param {Array<string>} [clusterStatus] cluster status
         * @param {Array<string>} [clusterVersion] cluster version
         * @param {Array<string>} [deployType] deploy type
         * @param {Array<string>} [deployTypeV2] deploy type v2
         * @param {Array<string>} [tenantPlan] tenant plan
         * @param {Array<string>} [controlPlane] control plane
         * @param {Array<string>} [provider] cloud provider
         * @param {Array<string>} [region] cloud region
         * @param {string} [sort] sort
         * @param {string} [order] order
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardClustersGet(xCsrfToken, query, showDeleted, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, controlPlane, provider, region, sort, order, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dashboardClustersGet(xCsrfToken, query, showDeleted, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, controlPlane, provider, region, sort, order, limit, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * proxy dashboard
         * @summary proxy dashboard
         * @param {string} host the proxy host
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardProxyGet(host, xCsrfToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dashboardProxyGet(host, xCsrfToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list regions
         * @summary list regions
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {Array<string>} [provider] cloud provdier, default for all providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardRegionsGet(xCsrfToken, provider, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dashboardRegionsGet(xCsrfToken, provider, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * GlobalDashboardApi - factory interface
 * @export
 */
export const GlobalDashboardApiFactory = function (configuration, basePath, axios) {
    const localVarFp = GlobalDashboardApiFp(configuration);
    return {
        /**
         * list cloud clusters QPS status
         * @summary list cloud clusters QPS status
         * @param {string} threshold threshold
         * @param {number} beginTs begin_ts
         * @param {number} endTs end_ts
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [search] search tenant name/id or cluster name/id
         * @param {Array<string>} [region] cluster region filter
         * @param {Array<string>} [deployType] deploy type filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardActiveqpsGet(threshold, beginTs, endTs, xCsrfToken, search, region, deployType, options) {
            return localVarFp.dashboardActiveqpsGet(threshold, beginTs, endTs, xCsrfToken, search, region, deployType, options).then((request) => request(axios, basePath));
        },
        /**
         * list cloud clusters status form local db
         * @summary list cloud clusters status form local db
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [query] search data from tenant id, tenant name, cluster id and cluster name
         * @param {Array<string>} [clusterId] cluster id
         * @param {Array<string>} [clusterStatus] cluster status
         * @param {Array<string>} [clusterVersion] cluster version
         * @param {Array<string>} [deployType] deploy type
         * @param {Array<string>} [deployTypeV2] deploy type v2
         * @param {Array<string>} [tenantPlan] tenant plan
         * @param {boolean} [showDeleted] show deleted cluster
         * @param {Array<string>} [controlPlane] control plane
         * @param {Array<string>} [provider] cloud provider
         * @param {Array<string>} [region] cloud region
         * @param {number} [createdTsFrom] created_at timestamp from
         * @param {number} [createdTsTo] created_at timestamp to
         * @param {number} [deletedTsFrom] deleted_at timestamp from
         * @param {number} [deletedTsTo] deleted_at timestamp to
         * @param {string} [sort] sort
         * @param {string} [order] order
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardClusters2Get(xCsrfToken, query, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, showDeleted, controlPlane, provider, region, createdTsFrom, createdTsTo, deletedTsFrom, deletedTsTo, sort, order, limit, page, options) {
            return localVarFp.dashboardClusters2Get(xCsrfToken, query, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, showDeleted, controlPlane, provider, region, createdTsFrom, createdTsTo, deletedTsFrom, deletedTsTo, sort, order, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * list cloud clusters status
         * @summary list cloud clusters status
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [query] search data from tenant id, tenant name, cluster id and cluster name
         * @param {boolean} [showDeleted] show deleted cluster
         * @param {Array<string>} [clusterId] cluster id
         * @param {Array<string>} [clusterStatus] cluster status
         * @param {Array<string>} [clusterVersion] cluster version
         * @param {Array<string>} [deployType] deploy type
         * @param {Array<string>} [deployTypeV2] deploy type v2
         * @param {Array<string>} [tenantPlan] tenant plan
         * @param {Array<string>} [controlPlane] control plane
         * @param {Array<string>} [provider] cloud provider
         * @param {Array<string>} [region] cloud region
         * @param {string} [sort] sort
         * @param {string} [order] order
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardClustersGet(xCsrfToken, query, showDeleted, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, controlPlane, provider, region, sort, order, limit, page, options) {
            return localVarFp.dashboardClustersGet(xCsrfToken, query, showDeleted, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, controlPlane, provider, region, sort, order, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * proxy dashboard
         * @summary proxy dashboard
         * @param {string} host the proxy host
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardProxyGet(host, xCsrfToken, options) {
            return localVarFp.dashboardProxyGet(host, xCsrfToken, options).then((request) => request(axios, basePath));
        },
        /**
         * list regions
         * @summary list regions
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {Array<string>} [provider] cloud provdier, default for all providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardRegionsGet(xCsrfToken, provider, options) {
            return localVarFp.dashboardRegionsGet(xCsrfToken, provider, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GlobalDashboardApi - object-oriented interface
 * @export
 * @class GlobalDashboardApi
 * @extends {BaseAPI}
 */
export class GlobalDashboardApi extends BaseAPI {
    /**
     * list cloud clusters QPS status
     * @summary list cloud clusters QPS status
     * @param {string} threshold threshold
     * @param {number} beginTs begin_ts
     * @param {number} endTs end_ts
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} [search] search tenant name/id or cluster name/id
     * @param {Array<string>} [region] cluster region filter
     * @param {Array<string>} [deployType] deploy type filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalDashboardApi
     */
    dashboardActiveqpsGet(threshold, beginTs, endTs, xCsrfToken, search, region, deployType, options) {
        return GlobalDashboardApiFp(this.configuration).dashboardActiveqpsGet(threshold, beginTs, endTs, xCsrfToken, search, region, deployType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list cloud clusters status form local db
     * @summary list cloud clusters status form local db
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} [query] search data from tenant id, tenant name, cluster id and cluster name
     * @param {Array<string>} [clusterId] cluster id
     * @param {Array<string>} [clusterStatus] cluster status
     * @param {Array<string>} [clusterVersion] cluster version
     * @param {Array<string>} [deployType] deploy type
     * @param {Array<string>} [deployTypeV2] deploy type v2
     * @param {Array<string>} [tenantPlan] tenant plan
     * @param {boolean} [showDeleted] show deleted cluster
     * @param {Array<string>} [controlPlane] control plane
     * @param {Array<string>} [provider] cloud provider
     * @param {Array<string>} [region] cloud region
     * @param {number} [createdTsFrom] created_at timestamp from
     * @param {number} [createdTsTo] created_at timestamp to
     * @param {number} [deletedTsFrom] deleted_at timestamp from
     * @param {number} [deletedTsTo] deleted_at timestamp to
     * @param {string} [sort] sort
     * @param {string} [order] order
     * @param {number} [limit] the count per page
     * @param {number} [page] the page index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalDashboardApi
     */
    dashboardClusters2Get(xCsrfToken, query, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, showDeleted, controlPlane, provider, region, createdTsFrom, createdTsTo, deletedTsFrom, deletedTsTo, sort, order, limit, page, options) {
        return GlobalDashboardApiFp(this.configuration).dashboardClusters2Get(xCsrfToken, query, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, showDeleted, controlPlane, provider, region, createdTsFrom, createdTsTo, deletedTsFrom, deletedTsTo, sort, order, limit, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list cloud clusters status
     * @summary list cloud clusters status
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} [query] search data from tenant id, tenant name, cluster id and cluster name
     * @param {boolean} [showDeleted] show deleted cluster
     * @param {Array<string>} [clusterId] cluster id
     * @param {Array<string>} [clusterStatus] cluster status
     * @param {Array<string>} [clusterVersion] cluster version
     * @param {Array<string>} [deployType] deploy type
     * @param {Array<string>} [deployTypeV2] deploy type v2
     * @param {Array<string>} [tenantPlan] tenant plan
     * @param {Array<string>} [controlPlane] control plane
     * @param {Array<string>} [provider] cloud provider
     * @param {Array<string>} [region] cloud region
     * @param {string} [sort] sort
     * @param {string} [order] order
     * @param {number} [limit] the count per page
     * @param {number} [page] the page index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalDashboardApi
     */
    dashboardClustersGet(xCsrfToken, query, showDeleted, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, controlPlane, provider, region, sort, order, limit, page, options) {
        return GlobalDashboardApiFp(this.configuration).dashboardClustersGet(xCsrfToken, query, showDeleted, clusterId, clusterStatus, clusterVersion, deployType, deployTypeV2, tenantPlan, controlPlane, provider, region, sort, order, limit, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * proxy dashboard
     * @summary proxy dashboard
     * @param {string} host the proxy host
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalDashboardApi
     */
    dashboardProxyGet(host, xCsrfToken, options) {
        return GlobalDashboardApiFp(this.configuration).dashboardProxyGet(host, xCsrfToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list regions
     * @summary list regions
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {Array<string>} [provider] cloud provdier, default for all providers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalDashboardApi
     */
    dashboardRegionsGet(xCsrfToken, provider, options) {
        return GlobalDashboardApiFp(this.configuration).dashboardRegionsGet(xCsrfToken, provider, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
export const HealthCheckApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * AI analyze for health check (internal users only)
         * @summary AI Health Check Analyze
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clinicApiV1HealthcheckAiAnalyzePost: (xCsrfToken_1, ...args_1) => __awaiter(this, [xCsrfToken_1, ...args_1], void 0, function* (xCsrfToken, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('clinicApiV1HealthcheckAiAnalyzePost', 'xCsrfToken', xCsrfToken);
            const localVarPath = `/clinic/api/v1/healthcheck/ai/analyze`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list health check results for a cluster
         * @summary List Health Check Results
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [page] the page index
         * @param {number} [limit] the count per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckResultGet: (xCsrfToken_1, oid_1, cid_1, page_1, limit_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, page_1, limit_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, page, limit, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckResultGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckResultGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckResultGet', 'cid', cid);
            const localVarPath = `/compute-engine/{oid}/{cid}/healthcheck/result`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete a health check result
         * @summary Delete Health Check Result
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid result uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckResultUuidDelete: (xCsrfToken_1, oid_1, cid_1, uuid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, uuid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, uuid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckResultUuidDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckResultUuidDelete', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckResultUuidDelete', 'cid', cid);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckResultUuidDelete', 'uuid', uuid);
            const localVarPath = `/compute-engine/{oid}/{cid}/healthcheck/result/{uuid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get a combined health check report by result uuid (returns all check items for the same report)
         * @summary Get Health Check Result
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid result uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckResultUuidGet: (xCsrfToken_1, oid_1, cid_1, uuid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, uuid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, uuid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckResultUuidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckResultUuidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckResultUuidGet', 'cid', cid);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckResultUuidGet', 'uuid', uuid);
            const localVarPath = `/compute-engine/{oid}/{cid}/healthcheck/result/{uuid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list health check strategies for a cluster
         * @summary List Health Check Strategies
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [page] the page index
         * @param {number} [limit] the count per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyGet: (xCsrfToken_1, oid_1, cid_1, page_1, limit_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, page_1, limit_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, page, limit, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyGet', 'cid', cid);
            const localVarPath = `/compute-engine/{oid}/{cid}/healthcheck/strategy`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create a new health check strategy with check items
         * @summary Create Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {HealthcheckHealthCheckStrategyReq} strategy health check strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyPost: (xCsrfToken_1, oid_1, cid_1, strategy_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, strategy_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, strategy, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyPost', 'cid', cid);
            // verify required parameter 'strategy' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyPost', 'strategy', strategy);
            const localVarPath = `/compute-engine/{oid}/{cid}/healthcheck/strategy`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(strategy, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete a health check strategy
         * @summary Delete Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidDelete: (xCsrfToken_1, oid_1, cid_1, uuid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, uuid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, uuid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidDelete', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidDelete', 'cid', cid);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidDelete', 'uuid', uuid);
            const localVarPath = `/compute-engine/{oid}/{cid}/healthcheck/strategy/{uuid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get a health check strategy by uuid
         * @summary Get Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidGet: (xCsrfToken_1, oid_1, cid_1, uuid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, uuid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, uuid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidGet', 'cid', cid);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidGet', 'uuid', uuid);
            const localVarPath = `/compute-engine/{oid}/{cid}/healthcheck/strategy/{uuid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * update a health check strategy (including items)
         * @summary Update Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {HealthcheckHealthCheckStrategyReq} strategy health check strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidPut: (xCsrfToken_1, oid_1, cid_1, uuid_1, strategy_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, uuid_1, strategy_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, uuid, strategy, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidPut', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidPut', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidPut', 'cid', cid);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidPut', 'uuid', uuid);
            // verify required parameter 'strategy' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidPut', 'strategy', strategy);
            const localVarPath = `/compute-engine/{oid}/{cid}/healthcheck/strategy/{uuid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(strategy, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * trigger health check for a strategy (runs all enabled items or specified items)
         * @summary Trigger Health Check
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {HealthcheckTriggerHealthCheckReq} [trigger] optional item selection and time range override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidTriggerPost: (xCsrfToken_1, oid_1, cid_1, uuid_1, trigger_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, uuid_1, trigger_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, uuid, trigger, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidTriggerPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidTriggerPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidTriggerPost', 'cid', cid);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthcheckStrategyUuidTriggerPost', 'uuid', uuid);
            const localVarPath = `/compute-engine/{oid}/{cid}/healthcheck/strategy/{uuid}/trigger`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(trigger, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
export const HealthCheckApiFp = function (configuration) {
    const localVarAxiosParamCreator = HealthCheckApiAxiosParamCreator(configuration);
    return {
        /**
         * AI analyze for health check (internal users only)
         * @summary AI Health Check Analyze
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clinicApiV1HealthcheckAiAnalyzePost(xCsrfToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clinicApiV1HealthcheckAiAnalyzePost(xCsrfToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list health check results for a cluster
         * @summary List Health Check Results
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [page] the page index
         * @param {number} [limit] the count per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckResultGet(xCsrfToken, oid, cid, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthcheckResultGet(xCsrfToken, oid, cid, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * delete a health check result
         * @summary Delete Health Check Result
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid result uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckResultUuidDelete(xCsrfToken, oid, cid, uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthcheckResultUuidDelete(xCsrfToken, oid, cid, uuid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get a combined health check report by result uuid (returns all check items for the same report)
         * @summary Get Health Check Result
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid result uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckResultUuidGet(xCsrfToken, oid, cid, uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthcheckResultUuidGet(xCsrfToken, oid, cid, uuid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list health check strategies for a cluster
         * @summary List Health Check Strategies
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [page] the page index
         * @param {number} [limit] the count per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyGet(xCsrfToken, oid, cid, page, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthcheckStrategyGet(xCsrfToken, oid, cid, page, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * create a new health check strategy with check items
         * @summary Create Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {HealthcheckHealthCheckStrategyReq} strategy health check strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyPost(xCsrfToken, oid, cid, strategy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthcheckStrategyPost(xCsrfToken, oid, cid, strategy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * delete a health check strategy
         * @summary Delete Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidDelete(xCsrfToken, oid, cid, uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthcheckStrategyUuidDelete(xCsrfToken, oid, cid, uuid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get a health check strategy by uuid
         * @summary Get Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidGet(xCsrfToken, oid, cid, uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthcheckStrategyUuidGet(xCsrfToken, oid, cid, uuid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * update a health check strategy (including items)
         * @summary Update Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {HealthcheckHealthCheckStrategyReq} strategy health check strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidPut(xCsrfToken, oid, cid, uuid, strategy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthcheckStrategyUuidPut(xCsrfToken, oid, cid, uuid, strategy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * trigger health check for a strategy (runs all enabled items or specified items)
         * @summary Trigger Health Check
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {HealthcheckTriggerHealthCheckReq} [trigger] optional item selection and time range override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidTriggerPost(xCsrfToken, oid, cid, uuid, trigger, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthcheckStrategyUuidTriggerPost(xCsrfToken, oid, cid, uuid, trigger, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * HealthCheckApi - factory interface
 * @export
 */
export const HealthCheckApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HealthCheckApiFp(configuration);
    return {
        /**
         * AI analyze for health check (internal users only)
         * @summary AI Health Check Analyze
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clinicApiV1HealthcheckAiAnalyzePost(xCsrfToken, options) {
            return localVarFp.clinicApiV1HealthcheckAiAnalyzePost(xCsrfToken, options).then((request) => request(axios, basePath));
        },
        /**
         * list health check results for a cluster
         * @summary List Health Check Results
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [page] the page index
         * @param {number} [limit] the count per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckResultGet(xCsrfToken, oid, cid, page, limit, options) {
            return localVarFp.computeEngineOidCidHealthcheckResultGet(xCsrfToken, oid, cid, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * delete a health check result
         * @summary Delete Health Check Result
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid result uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckResultUuidDelete(xCsrfToken, oid, cid, uuid, options) {
            return localVarFp.computeEngineOidCidHealthcheckResultUuidDelete(xCsrfToken, oid, cid, uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * get a combined health check report by result uuid (returns all check items for the same report)
         * @summary Get Health Check Result
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid result uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckResultUuidGet(xCsrfToken, oid, cid, uuid, options) {
            return localVarFp.computeEngineOidCidHealthcheckResultUuidGet(xCsrfToken, oid, cid, uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * list health check strategies for a cluster
         * @summary List Health Check Strategies
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [page] the page index
         * @param {number} [limit] the count per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyGet(xCsrfToken, oid, cid, page, limit, options) {
            return localVarFp.computeEngineOidCidHealthcheckStrategyGet(xCsrfToken, oid, cid, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * create a new health check strategy with check items
         * @summary Create Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {HealthcheckHealthCheckStrategyReq} strategy health check strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyPost(xCsrfToken, oid, cid, strategy, options) {
            return localVarFp.computeEngineOidCidHealthcheckStrategyPost(xCsrfToken, oid, cid, strategy, options).then((request) => request(axios, basePath));
        },
        /**
         * delete a health check strategy
         * @summary Delete Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidDelete(xCsrfToken, oid, cid, uuid, options) {
            return localVarFp.computeEngineOidCidHealthcheckStrategyUuidDelete(xCsrfToken, oid, cid, uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * get a health check strategy by uuid
         * @summary Get Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidGet(xCsrfToken, oid, cid, uuid, options) {
            return localVarFp.computeEngineOidCidHealthcheckStrategyUuidGet(xCsrfToken, oid, cid, uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * update a health check strategy (including items)
         * @summary Update Health Check Strategy
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {HealthcheckHealthCheckStrategyReq} strategy health check strategy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidPut(xCsrfToken, oid, cid, uuid, strategy, options) {
            return localVarFp.computeEngineOidCidHealthcheckStrategyUuidPut(xCsrfToken, oid, cid, uuid, strategy, options).then((request) => request(axios, basePath));
        },
        /**
         * trigger health check for a strategy (runs all enabled items or specified items)
         * @summary Trigger Health Check
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} uuid strategy uuid
         * @param {HealthcheckTriggerHealthCheckReq} [trigger] optional item selection and time range override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthcheckStrategyUuidTriggerPost(xCsrfToken, oid, cid, uuid, trigger, options) {
            return localVarFp.computeEngineOidCidHealthcheckStrategyUuidTriggerPost(xCsrfToken, oid, cid, uuid, trigger, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
export class HealthCheckApi extends BaseAPI {
    /**
     * AI analyze for health check (internal users only)
     * @summary AI Health Check Analyze
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    clinicApiV1HealthcheckAiAnalyzePost(xCsrfToken, options) {
        return HealthCheckApiFp(this.configuration).clinicApiV1HealthcheckAiAnalyzePost(xCsrfToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list health check results for a cluster
     * @summary List Health Check Results
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {number} [page] the page index
     * @param {number} [limit] the count per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    computeEngineOidCidHealthcheckResultGet(xCsrfToken, oid, cid, page, limit, options) {
        return HealthCheckApiFp(this.configuration).computeEngineOidCidHealthcheckResultGet(xCsrfToken, oid, cid, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete a health check result
     * @summary Delete Health Check Result
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} uuid result uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    computeEngineOidCidHealthcheckResultUuidDelete(xCsrfToken, oid, cid, uuid, options) {
        return HealthCheckApiFp(this.configuration).computeEngineOidCidHealthcheckResultUuidDelete(xCsrfToken, oid, cid, uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get a combined health check report by result uuid (returns all check items for the same report)
     * @summary Get Health Check Result
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} uuid result uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    computeEngineOidCidHealthcheckResultUuidGet(xCsrfToken, oid, cid, uuid, options) {
        return HealthCheckApiFp(this.configuration).computeEngineOidCidHealthcheckResultUuidGet(xCsrfToken, oid, cid, uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list health check strategies for a cluster
     * @summary List Health Check Strategies
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {number} [page] the page index
     * @param {number} [limit] the count per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    computeEngineOidCidHealthcheckStrategyGet(xCsrfToken, oid, cid, page, limit, options) {
        return HealthCheckApiFp(this.configuration).computeEngineOidCidHealthcheckStrategyGet(xCsrfToken, oid, cid, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create a new health check strategy with check items
     * @summary Create Health Check Strategy
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {HealthcheckHealthCheckStrategyReq} strategy health check strategy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    computeEngineOidCidHealthcheckStrategyPost(xCsrfToken, oid, cid, strategy, options) {
        return HealthCheckApiFp(this.configuration).computeEngineOidCidHealthcheckStrategyPost(xCsrfToken, oid, cid, strategy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete a health check strategy
     * @summary Delete Health Check Strategy
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} uuid strategy uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    computeEngineOidCidHealthcheckStrategyUuidDelete(xCsrfToken, oid, cid, uuid, options) {
        return HealthCheckApiFp(this.configuration).computeEngineOidCidHealthcheckStrategyUuidDelete(xCsrfToken, oid, cid, uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get a health check strategy by uuid
     * @summary Get Health Check Strategy
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} uuid strategy uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    computeEngineOidCidHealthcheckStrategyUuidGet(xCsrfToken, oid, cid, uuid, options) {
        return HealthCheckApiFp(this.configuration).computeEngineOidCidHealthcheckStrategyUuidGet(xCsrfToken, oid, cid, uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * update a health check strategy (including items)
     * @summary Update Health Check Strategy
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} uuid strategy uuid
     * @param {HealthcheckHealthCheckStrategyReq} strategy health check strategy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    computeEngineOidCidHealthcheckStrategyUuidPut(xCsrfToken, oid, cid, uuid, strategy, options) {
        return HealthCheckApiFp(this.configuration).computeEngineOidCidHealthcheckStrategyUuidPut(xCsrfToken, oid, cid, uuid, strategy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * trigger health check for a strategy (runs all enabled items or specified items)
     * @summary Trigger Health Check
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} uuid strategy uuid
     * @param {HealthcheckTriggerHealthCheckReq} [trigger] optional item selection and time range override
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    computeEngineOidCidHealthcheckStrategyUuidTriggerPost(xCsrfToken, oid, cid, uuid, trigger, options) {
        return HealthCheckApiFp(this.configuration).computeEngineOidCidHealthcheckStrategyUuidTriggerPost(xCsrfToken, oid, cid, uuid, trigger, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HealthReportApi - axios parameter creator
 * @export
 */
export const HealthReportApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * list health report
         * @summary list health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [startTime] start time
         * @param {number} [endTime] end time
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthGet: (xCsrfToken_1, oid_1, cid_1, startTime_1, endTime_1, brief_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, startTime_1, endTime_1, brief_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, startTime, endTime, brief, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthGet', 'cid', cid);
            const localVarPath = `/compute-engine/{oid}/{cid}/health`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (brief !== undefined) {
                localVarQueryParameter['brief'] = brief;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * touch Health report in on cluster
         * @summary Touch New Health Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {OldreportHealthReportReq} reportParams health report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthPost: (xCsrfToken_1, oid_1, cid_1, reportParams_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, reportParams_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, reportParams, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthPost', 'cid', cid);
            // verify required parameter 'reportParams' is not null or undefined
            assertParamExists('computeEngineOidCidHealthPost', 'reportParams', reportParams);
            const localVarPath = `/compute-engine/{oid}/{cid}/health`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(reportParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete health report
         * @summary delete health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthRidDelete: (xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, rid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthRidDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthRidDelete', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthRidDelete', 'cid', cid);
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthRidDelete', 'rid', rid);
            const localVarPath = `/compute-engine/{oid}/{cid}/health/{rid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list health report
         * @summary get health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthRidGet: (xCsrfToken_1, oid_1, cid_1, rid_1, brief_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, rid_1, brief_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, rid, brief, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidHealthRidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthRidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthRidGet', 'cid', cid);
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('computeEngineOidCidHealthRidGet', 'rid', rid);
            const localVarPath = `/compute-engine/{oid}/{cid}/health/{rid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (brief !== undefined) {
                localVarQueryParameter['brief'] = brief;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * HealthReportApi - functional programming interface
 * @export
 */
export const HealthReportApiFp = function (configuration) {
    const localVarAxiosParamCreator = HealthReportApiAxiosParamCreator(configuration);
    return {
        /**
         * list health report
         * @summary list health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [startTime] start time
         * @param {number} [endTime] end time
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthGet(xCsrfToken, oid, cid, startTime, endTime, brief, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthGet(xCsrfToken, oid, cid, startTime, endTime, brief, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * touch Health report in on cluster
         * @summary Touch New Health Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {OldreportHealthReportReq} reportParams health report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthPost(xCsrfToken, oid, cid, reportParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthPost(xCsrfToken, oid, cid, reportParams, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * delete health report
         * @summary delete health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthRidDelete(xCsrfToken, oid, cid, rid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthRidDelete(xCsrfToken, oid, cid, rid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list health report
         * @summary get health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthRidGet(xCsrfToken, oid, cid, rid, brief, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidHealthRidGet(xCsrfToken, oid, cid, rid, brief, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * HealthReportApi - factory interface
 * @export
 */
export const HealthReportApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HealthReportApiFp(configuration);
    return {
        /**
         * list health report
         * @summary list health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [startTime] start time
         * @param {number} [endTime] end time
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthGet(xCsrfToken, oid, cid, startTime, endTime, brief, options) {
            return localVarFp.computeEngineOidCidHealthGet(xCsrfToken, oid, cid, startTime, endTime, brief, options).then((request) => request(axios, basePath));
        },
        /**
         * touch Health report in on cluster
         * @summary Touch New Health Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {OldreportHealthReportReq} reportParams health report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthPost(xCsrfToken, oid, cid, reportParams, options) {
            return localVarFp.computeEngineOidCidHealthPost(xCsrfToken, oid, cid, reportParams, options).then((request) => request(axios, basePath));
        },
        /**
         * delete health report
         * @summary delete health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthRidDelete(xCsrfToken, oid, cid, rid, options) {
            return localVarFp.computeEngineOidCidHealthRidDelete(xCsrfToken, oid, cid, rid, options).then((request) => request(axios, basePath));
        },
        /**
         * list health report
         * @summary get health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidHealthRidGet(xCsrfToken, oid, cid, rid, brief, options) {
            return localVarFp.computeEngineOidCidHealthRidGet(xCsrfToken, oid, cid, rid, brief, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HealthReportApi - object-oriented interface
 * @export
 * @class HealthReportApi
 * @extends {BaseAPI}
 */
export class HealthReportApi extends BaseAPI {
    /**
     * list health report
     * @summary list health report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {number} [startTime] start time
     * @param {number} [endTime] end time
     * @param {boolean} [brief] if need data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthReportApi
     */
    computeEngineOidCidHealthGet(xCsrfToken, oid, cid, startTime, endTime, brief, options) {
        return HealthReportApiFp(this.configuration).computeEngineOidCidHealthGet(xCsrfToken, oid, cid, startTime, endTime, brief, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * touch Health report in on cluster
     * @summary Touch New Health Report Job
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {OldreportHealthReportReq} reportParams health report param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthReportApi
     */
    computeEngineOidCidHealthPost(xCsrfToken, oid, cid, reportParams, options) {
        return HealthReportApiFp(this.configuration).computeEngineOidCidHealthPost(xCsrfToken, oid, cid, reportParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete health report
     * @summary delete health report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} rid report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthReportApi
     */
    computeEngineOidCidHealthRidDelete(xCsrfToken, oid, cid, rid, options) {
        return HealthReportApiFp(this.configuration).computeEngineOidCidHealthRidDelete(xCsrfToken, oid, cid, rid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list health report
     * @summary get health report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} rid report id
     * @param {boolean} [brief] if need data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthReportApi
     */
    computeEngineOidCidHealthRidGet(xCsrfToken, oid, cid, rid, brief, options) {
        return HealthReportApiFp(this.configuration).computeEngineOidCidHealthRidGet(xCsrfToken, oid, cid, rid, brief, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InternalApi - axios parameter creator
 * @export
 */
export const InternalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get comprehensive cluster information including data URLs (internal API)
         * @summary Get cluster data URLs
         * @param {string} clusterId cluster id (cluster_id field, not the primary key id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalClustersClusterIdClusterDataurlsGet: (clusterId_1, ...args_1) => __awaiter(this, [clusterId_1, ...args_1], void 0, function* (clusterId, options = {}) {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('internalClustersClusterIdClusterDataurlsGet', 'clusterId', clusterId);
            const localVarPath = `/internal/clusters/{cluster_id}/cluster-dataurls`
                .replace(`{${"cluster_id"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InternalApi - functional programming interface
 * @export
 */
export const InternalApiFp = function (configuration) {
    const localVarAxiosParamCreator = InternalApiAxiosParamCreator(configuration);
    return {
        /**
         * Get comprehensive cluster information including data URLs (internal API)
         * @summary Get cluster data URLs
         * @param {string} clusterId cluster id (cluster_id field, not the primary key id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalClustersClusterIdClusterDataurlsGet(clusterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalClustersClusterIdClusterDataurlsGet(clusterId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * InternalApi - factory interface
 * @export
 */
export const InternalApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InternalApiFp(configuration);
    return {
        /**
         * Get comprehensive cluster information including data URLs (internal API)
         * @summary Get cluster data URLs
         * @param {string} clusterId cluster id (cluster_id field, not the primary key id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalClustersClusterIdClusterDataurlsGet(clusterId, options) {
            return localVarFp.internalClustersClusterIdClusterDataurlsGet(clusterId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InternalApi - object-oriented interface
 * @export
 * @class InternalApi
 * @extends {BaseAPI}
 */
export class InternalApi extends BaseAPI {
    /**
     * Get comprehensive cluster information including data URLs (internal API)
     * @summary Get cluster data URLs
     * @param {string} clusterId cluster id (cluster_id field, not the primary key id)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    internalClustersClusterIdClusterDataurlsGet(clusterId, options) {
        return InternalApiFp(this.configuration).internalClustersClusterIdClusterDataurlsGet(clusterId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InternalKeyApi - axios parameter creator
 * @export
 */
export const InternalKeyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * List all API keys for the current internal user
         * @summary List internal API keys
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalKeysGet: (xCsrfToken_1, limit_1, page_1, ...args_1) => __awaiter(this, [xCsrfToken_1, limit_1, page_1, ...args_1], void 0, function* (xCsrfToken, limit, page, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('internalKeysGet', 'xCsrfToken', xCsrfToken);
            const localVarPath = `/internal/keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete an API key for the current internal user
         * @summary Delete internal API key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {number} id key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalKeysIdDelete: (xCsrfToken_1, id_1, ...args_1) => __awaiter(this, [xCsrfToken_1, id_1, ...args_1], void 0, function* (xCsrfToken, id, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('internalKeysIdDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalKeysIdDelete', 'id', id);
            const localVarPath = `/internal/keys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create an API key for internal users (internal=true only)
         * @summary Create internal API key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {InternalKeyCreateKeyRequest} [body] optional key name and expiration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalKeysPost: (xCsrfToken_1, body_1, ...args_1) => __awaiter(this, [xCsrfToken_1, body_1, ...args_1], void 0, function* (xCsrfToken, body, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('internalKeysPost', 'xCsrfToken', xCsrfToken);
            const localVarPath = `/internal/keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InternalKeyApi - functional programming interface
 * @export
 */
export const InternalKeyApiFp = function (configuration) {
    const localVarAxiosParamCreator = InternalKeyApiAxiosParamCreator(configuration);
    return {
        /**
         * List all API keys for the current internal user
         * @summary List internal API keys
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalKeysGet(xCsrfToken, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalKeysGet(xCsrfToken, limit, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Delete an API key for the current internal user
         * @summary Delete internal API key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {number} id key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalKeysIdDelete(xCsrfToken, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalKeysIdDelete(xCsrfToken, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Create an API key for internal users (internal=true only)
         * @summary Create internal API key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {InternalKeyCreateKeyRequest} [body] optional key name and expiration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalKeysPost(xCsrfToken, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalKeysPost(xCsrfToken, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * InternalKeyApi - factory interface
 * @export
 */
export const InternalKeyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InternalKeyApiFp(configuration);
    return {
        /**
         * List all API keys for the current internal user
         * @summary List internal API keys
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalKeysGet(xCsrfToken, limit, page, options) {
            return localVarFp.internalKeysGet(xCsrfToken, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an API key for the current internal user
         * @summary Delete internal API key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {number} id key id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalKeysIdDelete(xCsrfToken, id, options) {
            return localVarFp.internalKeysIdDelete(xCsrfToken, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an API key for internal users (internal=true only)
         * @summary Create internal API key
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {InternalKeyCreateKeyRequest} [body] optional key name and expiration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalKeysPost(xCsrfToken, body, options) {
            return localVarFp.internalKeysPost(xCsrfToken, body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InternalKeyApi - object-oriented interface
 * @export
 * @class InternalKeyApi
 * @extends {BaseAPI}
 */
export class InternalKeyApi extends BaseAPI {
    /**
     * List all API keys for the current internal user
     * @summary List internal API keys
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {number} [limit] the count per page
     * @param {number} [page] the page index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalKeyApi
     */
    internalKeysGet(xCsrfToken, limit, page, options) {
        return InternalKeyApiFp(this.configuration).internalKeysGet(xCsrfToken, limit, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an API key for the current internal user
     * @summary Delete internal API key
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {number} id key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalKeyApi
     */
    internalKeysIdDelete(xCsrfToken, id, options) {
        return InternalKeyApiFp(this.configuration).internalKeysIdDelete(xCsrfToken, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create an API key for internal users (internal=true only)
     * @summary Create internal API key
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {InternalKeyCreateKeyRequest} [body] optional key name and expiration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalKeyApi
     */
    internalKeysPost(xCsrfToken, body, options) {
        return InternalKeyApiFp(this.configuration).internalKeysPost(xCsrfToken, body, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MetricApi - axios parameter creator
 * @export
 */
export const MetricApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * get the dbaas control plane metrics data
         * @summary Get the dbaas control plane metrics data
         * @param {string} controlPlaneInfo the control plane info
         * @param {string} query prometheus query
         * @param {number} [start] the start timestamp of query data
         * @param {number} [end] the end timestamp of query data
         * @param {string} [step] prometheus step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataControlPlaneMetricsGet: (controlPlaneInfo_1, query_1, start_1, end_1, step_1, ...args_1) => __awaiter(this, [controlPlaneInfo_1, query_1, start_1, end_1, step_1, ...args_1], void 0, function* (controlPlaneInfo, query, start, end, step, options = {}) {
            // verify required parameter 'controlPlaneInfo' is not null or undefined
            assertParamExists('dataControlPlaneMetricsGet', 'controlPlaneInfo', controlPlaneInfo);
            // verify required parameter 'query' is not null or undefined
            assertParamExists('dataControlPlaneMetricsGet', 'query', query);
            const localVarPath = `/data/control_plane/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }
            if (controlPlaneInfo !== undefined && controlPlaneInfo !== null) {
                localVarHeaderParameter['control_plane_info'] = String(controlPlaneInfo);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get the metrics data
         * @summary Get the metrics data
         * @param {'cloud' | 'op'} xOrgType string enums
         * @param {string} xOrgID the org id in clinic
         * @param {string} xClusterID cluster id
         * @param {string} query prometheus query
         * @param {number} [start] the start timestamp of query data
         * @param {number} [end] the end timestamp of query data
         * @param {string} [step] prometheus step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataMetricsGet: (xOrgType_1, xOrgID_1, xClusterID_1, query_1, start_1, end_1, step_1, ...args_1) => __awaiter(this, [xOrgType_1, xOrgID_1, xClusterID_1, query_1, start_1, end_1, step_1, ...args_1], void 0, function* (xOrgType, xOrgID, xClusterID, query, start, end, step, options = {}) {
            // verify required parameter 'xOrgType' is not null or undefined
            assertParamExists('dataMetricsGet', 'xOrgType', xOrgType);
            // verify required parameter 'xOrgID' is not null or undefined
            assertParamExists('dataMetricsGet', 'xOrgID', xOrgID);
            // verify required parameter 'xClusterID' is not null or undefined
            assertParamExists('dataMetricsGet', 'xClusterID', xClusterID);
            // verify required parameter 'query' is not null or undefined
            assertParamExists('dataMetricsGet', 'query', query);
            const localVarPath = `/data/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }
            if (xOrgType !== undefined && xOrgType !== null) {
                localVarHeaderParameter['X-OrgType'] = String(xOrgType);
            }
            if (xOrgID !== undefined && xOrgID !== null) {
                localVarHeaderParameter['X-OrgID'] = String(xOrgID);
            }
            if (xClusterID !== undefined && xClusterID !== null) {
                localVarHeaderParameter['X-ClusterID'] = String(xClusterID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MetricApi - functional programming interface
 * @export
 */
export const MetricApiFp = function (configuration) {
    const localVarAxiosParamCreator = MetricApiAxiosParamCreator(configuration);
    return {
        /**
         * get the dbaas control plane metrics data
         * @summary Get the dbaas control plane metrics data
         * @param {string} controlPlaneInfo the control plane info
         * @param {string} query prometheus query
         * @param {number} [start] the start timestamp of query data
         * @param {number} [end] the end timestamp of query data
         * @param {string} [step] prometheus step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataControlPlaneMetricsGet(controlPlaneInfo, query, start, end, step, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dataControlPlaneMetricsGet(controlPlaneInfo, query, start, end, step, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get the metrics data
         * @summary Get the metrics data
         * @param {'cloud' | 'op'} xOrgType string enums
         * @param {string} xOrgID the org id in clinic
         * @param {string} xClusterID cluster id
         * @param {string} query prometheus query
         * @param {number} [start] the start timestamp of query data
         * @param {number} [end] the end timestamp of query data
         * @param {string} [step] prometheus step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataMetricsGet(xOrgType, xOrgID, xClusterID, query, start, end, step, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dataMetricsGet(xOrgType, xOrgID, xClusterID, query, start, end, step, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MetricApi - factory interface
 * @export
 */
export const MetricApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MetricApiFp(configuration);
    return {
        /**
         * get the dbaas control plane metrics data
         * @summary Get the dbaas control plane metrics data
         * @param {string} controlPlaneInfo the control plane info
         * @param {string} query prometheus query
         * @param {number} [start] the start timestamp of query data
         * @param {number} [end] the end timestamp of query data
         * @param {string} [step] prometheus step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataControlPlaneMetricsGet(controlPlaneInfo, query, start, end, step, options) {
            return localVarFp.dataControlPlaneMetricsGet(controlPlaneInfo, query, start, end, step, options).then((request) => request(axios, basePath));
        },
        /**
         * get the metrics data
         * @summary Get the metrics data
         * @param {'cloud' | 'op'} xOrgType string enums
         * @param {string} xOrgID the org id in clinic
         * @param {string} xClusterID cluster id
         * @param {string} query prometheus query
         * @param {number} [start] the start timestamp of query data
         * @param {number} [end] the end timestamp of query data
         * @param {string} [step] prometheus step
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataMetricsGet(xOrgType, xOrgID, xClusterID, query, start, end, step, options) {
            return localVarFp.dataMetricsGet(xOrgType, xOrgID, xClusterID, query, start, end, step, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MetricApi - object-oriented interface
 * @export
 * @class MetricApi
 * @extends {BaseAPI}
 */
export class MetricApi extends BaseAPI {
    /**
     * get the dbaas control plane metrics data
     * @summary Get the dbaas control plane metrics data
     * @param {string} controlPlaneInfo the control plane info
     * @param {string} query prometheus query
     * @param {number} [start] the start timestamp of query data
     * @param {number} [end] the end timestamp of query data
     * @param {string} [step] prometheus step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricApi
     */
    dataControlPlaneMetricsGet(controlPlaneInfo, query, start, end, step, options) {
        return MetricApiFp(this.configuration).dataControlPlaneMetricsGet(controlPlaneInfo, query, start, end, step, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get the metrics data
     * @summary Get the metrics data
     * @param {'cloud' | 'op'} xOrgType string enums
     * @param {string} xOrgID the org id in clinic
     * @param {string} xClusterID cluster id
     * @param {string} query prometheus query
     * @param {number} [start] the start timestamp of query data
     * @param {number} [end] the end timestamp of query data
     * @param {string} [step] prometheus step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricApi
     */
    dataMetricsGet(xOrgType, xOrgID, xClusterID, query, start, end, step, options) {
        return MetricApiFp(this.configuration).dataMetricsGet(xOrgType, xOrgID, xClusterID, query, start, end, step, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OAuthApi - axios parameter creator
 * @export
 */
export const OAuthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * log out
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginLogoutPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/login/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get oauth config
         * @summary Config the user
         * @param {'internal' | 'ask_tug' | 'tidbcloud' | 'pingkai'} name string enums
         * @param {string} redirectUri the redirect_uri request parameter is used as a callback URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginOauthNameInfoGet: (name_1, redirectUri_1, ...args_1) => __awaiter(this, [name_1, redirectUri_1, ...args_1], void 0, function* (name, redirectUri, options = {}) {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('loginOauthNameInfoGet', 'name', name);
            // verify required parameter 'redirectUri' is not null or undefined
            assertParamExists('loginOauthNameInfoGet', 'redirectUri', redirectUri);
            const localVarPath = `/login/oauth/{name}/info`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (redirectUri !== undefined) {
                localVarQueryParameter['redirect_uri'] = redirectUri;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * set auth header
         * @summary Validate the user
         * @param {'internal' | 'ask_tug' | 'tidbcloud' | 'pingkai'} name string enums
         * @param {LoginValidation} validation validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginOauthNameValidatePost: (name_1, validation_1, ...args_1) => __awaiter(this, [name_1, validation_1, ...args_1], void 0, function* (name, validation, options = {}) {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('loginOauthNameValidatePost', 'name', name);
            // verify required parameter 'validation' is not null or undefined
            assertParamExists('loginOauthNameValidatePost', 'validation', validation);
            const localVarPath = `/login/oauth/{name}/validate`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(validation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OAuthApi - functional programming interface
 * @export
 */
export const OAuthApiFp = function (configuration) {
    const localVarAxiosParamCreator = OAuthApiAxiosParamCreator(configuration);
    return {
        /**
         * log out
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginLogoutPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loginLogoutPost(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get oauth config
         * @summary Config the user
         * @param {'internal' | 'ask_tug' | 'tidbcloud' | 'pingkai'} name string enums
         * @param {string} redirectUri the redirect_uri request parameter is used as a callback URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginOauthNameInfoGet(name, redirectUri, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loginOauthNameInfoGet(name, redirectUri, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * set auth header
         * @summary Validate the user
         * @param {'internal' | 'ask_tug' | 'tidbcloud' | 'pingkai'} name string enums
         * @param {LoginValidation} validation validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginOauthNameValidatePost(name, validation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loginOauthNameValidatePost(name, validation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OAuthApi - factory interface
 * @export
 */
export const OAuthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OAuthApiFp(configuration);
    return {
        /**
         * log out
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginLogoutPost(options) {
            return localVarFp.loginLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * get oauth config
         * @summary Config the user
         * @param {'internal' | 'ask_tug' | 'tidbcloud' | 'pingkai'} name string enums
         * @param {string} redirectUri the redirect_uri request parameter is used as a callback URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginOauthNameInfoGet(name, redirectUri, options) {
            return localVarFp.loginOauthNameInfoGet(name, redirectUri, options).then((request) => request(axios, basePath));
        },
        /**
         * set auth header
         * @summary Validate the user
         * @param {'internal' | 'ask_tug' | 'tidbcloud' | 'pingkai'} name string enums
         * @param {LoginValidation} validation validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginOauthNameValidatePost(name, validation, options) {
            return localVarFp.loginOauthNameValidatePost(name, validation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OAuthApi - object-oriented interface
 * @export
 * @class OAuthApi
 * @extends {BaseAPI}
 */
export class OAuthApi extends BaseAPI {
    /**
     * log out
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    loginLogoutPost(options) {
        return OAuthApiFp(this.configuration).loginLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get oauth config
     * @summary Config the user
     * @param {'internal' | 'ask_tug' | 'tidbcloud' | 'pingkai'} name string enums
     * @param {string} redirectUri the redirect_uri request parameter is used as a callback URL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    loginOauthNameInfoGet(name, redirectUri, options) {
        return OAuthApiFp(this.configuration).loginOauthNameInfoGet(name, redirectUri, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * set auth header
     * @summary Validate the user
     * @param {'internal' | 'ask_tug' | 'tidbcloud' | 'pingkai'} name string enums
     * @param {LoginValidation} validation validation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    loginOauthNameValidatePost(name, validation, options) {
        return OAuthApiFp(this.configuration).loginOauthNameValidatePost(name, validation, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrganizationApi - axios parameter creator
 * @export
 */
export const OrganizationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * get organization by external id
         * @summary Get the organization by external id
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} eid external id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsExternalEidGet: (xCsrfToken_1, eid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, eid_1, ...args_1], void 0, function* (xCsrfToken, eid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsExternalEidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'eid' is not null or undefined
            assertParamExists('orgsExternalEidGet', 'eid', eid);
            const localVarPath = `/orgs/external/{eid}`
                .replace(`{${"eid"}}`, encodeURIComponent(String(eid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list organization
         * @summary List the organizations
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [query] the organization name
         * @param {string} [filter] filter condition, can be all,starred,mine
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsGet: (xCsrfToken_1, query_1, filter_1, limit_1, page_1, ...args_1) => __awaiter(this, [xCsrfToken_1, query_1, filter_1, limit_1, page_1, ...args_1], void 0, function* (xCsrfToken, query, filter, limit, page, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsGet', 'xCsrfToken', xCsrfToken);
            const localVarPath = `/orgs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete Organization and data
         * @summary delete Organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDelete: (xCsrfToken_1, oid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, ...args_1], void 0, function* (xCsrfToken, oid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidDelete', 'oid', oid);
            const localVarPath = `/orgs/{oid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get organization
         * @summary Get the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidGet: (xCsrfToken_1, oid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, ...args_1], void 0, function* (xCsrfToken, oid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidGet', 'oid', oid);
            const localVarPath = `/orgs/{oid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list projects of the specified organization (only for cloud orgs)
         * @summary List projects
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidProjectsGet: (xCsrfToken_1, oid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, ...args_1], void 0, function* (xCsrfToken, oid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidProjectsGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidProjectsGet', 'oid', oid);
            const localVarPath = `/orgs/{oid}/projects`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * update organization
         * @summary Update the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {OrgUpdateOrganizationReq} organization organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidPut: (xCsrfToken_1, oid_1, organization_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, organization_1, ...args_1], void 0, function* (xCsrfToken, oid, organization, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidPut', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidPut', 'oid', oid);
            // verify required parameter 'organization' is not null or undefined
            assertParamExists('orgsOidPut', 'organization', organization);
            const localVarPath = `/orgs/{oid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(organization, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list organization roles
         * @summary List the organizations roles
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidRolesGet: (xCsrfToken_1, oid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, ...args_1], void 0, function* (xCsrfToken, oid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidRolesGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidRolesGet', 'oid', oid);
            const localVarPath = `/orgs/{oid}/roles`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * unstar organization
         * @summary UnStar the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidStarDelete: (xCsrfToken_1, oid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, ...args_1], void 0, function* (xCsrfToken, oid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidStarDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidStarDelete', 'oid', oid);
            const localVarPath = `/orgs/{oid}/star`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * star organization
         * @summary Star the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidStarPost: (xCsrfToken_1, oid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, ...args_1], void 0, function* (xCsrfToken, oid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidStarPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidStarPost', 'oid', oid);
            const localVarPath = `/orgs/{oid}/star`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get organization task list
         * @summary Get the organization task list
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidTasksGet: (xCsrfToken_1, oid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, ...args_1], void 0, function* (xCsrfToken, oid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidTasksGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidTasksGet', 'oid', oid);
            const localVarPath = `/orgs/{oid}/tasks`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list users of the organization
         * @summary List users
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersGet: (xCsrfToken_1, oid_1, limit_1, page_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, limit_1, page_1, ...args_1], void 0, function* (xCsrfToken, oid, limit, page, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidUsersGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidUsersGet', 'oid', oid);
            const localVarPath = `/orgs/{oid}/users`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete user from organization
         * @summary Delete user from organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} id user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersIdDelete: (xCsrfToken_1, oid_1, id_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, id_1, ...args_1], void 0, function* (xCsrfToken, oid, id, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidUsersIdDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidUsersIdDelete', 'oid', oid);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orgsOidUsersIdDelete', 'id', id);
            const localVarPath = `/orgs/{oid}/users/{id}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * update user role in organization
         * @summary Update user role in organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} id user id
         * @param {OrgRole} role user role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersIdPut: (xCsrfToken_1, oid_1, id_1, role_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, id_1, role_1, ...args_1], void 0, function* (xCsrfToken, oid, id, role, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidUsersIdPut', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidUsersIdPut', 'oid', oid);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orgsOidUsersIdPut', 'id', id);
            // verify required parameter 'role' is not null or undefined
            assertParamExists('orgsOidUsersIdPut', 'role', role);
            const localVarPath = `/orgs/{oid}/users/{id}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(role, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * invite user to join the organization
         * @summary Invite user
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {OrgInvitesReq} invite invite user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersInvitePost: (xCsrfToken_1, oid_1, invite_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, invite_1, ...args_1], void 0, function* (xCsrfToken, oid, invite, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidUsersInvitePost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidUsersInvitePost', 'oid', oid);
            // verify required parameter 'invite' is not null or undefined
            assertParamExists('orgsOidUsersInvitePost', 'invite', invite);
            const localVarPath = `/orgs/{oid}/users/invite`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(invite, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create organization
         * @summary Create the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {OrgOrganization} organization organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsPost: (xCsrfToken_1, organization_1, ...args_1) => __awaiter(this, [xCsrfToken_1, organization_1, ...args_1], void 0, function* (xCsrfToken, organization, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'organization' is not null or undefined
            assertParamExists('orgsPost', 'organization', organization);
            const localVarPath = `/orgs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(organization, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OrganizationApi - functional programming interface
 * @export
 */
export const OrganizationApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganizationApiAxiosParamCreator(configuration);
    return {
        /**
         * get organization by external id
         * @summary Get the organization by external id
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} eid external id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsExternalEidGet(xCsrfToken, eid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsExternalEidGet(xCsrfToken, eid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list organization
         * @summary List the organizations
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [query] the organization name
         * @param {string} [filter] filter condition, can be all,starred,mine
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsGet(xCsrfToken, query, filter, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsGet(xCsrfToken, query, filter, limit, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * delete Organization and data
         * @summary delete Organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDelete(xCsrfToken, oid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidDelete(xCsrfToken, oid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get organization
         * @summary Get the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidGet(xCsrfToken, oid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidGet(xCsrfToken, oid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list projects of the specified organization (only for cloud orgs)
         * @summary List projects
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidProjectsGet(xCsrfToken, oid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidProjectsGet(xCsrfToken, oid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * update organization
         * @summary Update the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {OrgUpdateOrganizationReq} organization organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidPut(xCsrfToken, oid, organization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidPut(xCsrfToken, oid, organization, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list organization roles
         * @summary List the organizations roles
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidRolesGet(xCsrfToken, oid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidRolesGet(xCsrfToken, oid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * unstar organization
         * @summary UnStar the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidStarDelete(xCsrfToken, oid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidStarDelete(xCsrfToken, oid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * star organization
         * @summary Star the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidStarPost(xCsrfToken, oid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidStarPost(xCsrfToken, oid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get organization task list
         * @summary Get the organization task list
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidTasksGet(xCsrfToken, oid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidTasksGet(xCsrfToken, oid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list users of the organization
         * @summary List users
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersGet(xCsrfToken, oid, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidUsersGet(xCsrfToken, oid, limit, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * delete user from organization
         * @summary Delete user from organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} id user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersIdDelete(xCsrfToken, oid, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidUsersIdDelete(xCsrfToken, oid, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * update user role in organization
         * @summary Update user role in organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} id user id
         * @param {OrgRole} role user role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersIdPut(xCsrfToken, oid, id, role, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidUsersIdPut(xCsrfToken, oid, id, role, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * invite user to join the organization
         * @summary Invite user
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {OrgInvitesReq} invite invite user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersInvitePost(xCsrfToken, oid, invite, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidUsersInvitePost(xCsrfToken, oid, invite, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * create organization
         * @summary Create the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {OrgOrganization} organization organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsPost(xCsrfToken, organization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsPost(xCsrfToken, organization, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OrganizationApi - factory interface
 * @export
 */
export const OrganizationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganizationApiFp(configuration);
    return {
        /**
         * get organization by external id
         * @summary Get the organization by external id
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} eid external id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsExternalEidGet(xCsrfToken, eid, options) {
            return localVarFp.orgsExternalEidGet(xCsrfToken, eid, options).then((request) => request(axios, basePath));
        },
        /**
         * list organization
         * @summary List the organizations
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} [query] the organization name
         * @param {string} [filter] filter condition, can be all,starred,mine
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsGet(xCsrfToken, query, filter, limit, page, options) {
            return localVarFp.orgsGet(xCsrfToken, query, filter, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * delete Organization and data
         * @summary delete Organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDelete(xCsrfToken, oid, options) {
            return localVarFp.orgsOidDelete(xCsrfToken, oid, options).then((request) => request(axios, basePath));
        },
        /**
         * get organization
         * @summary Get the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidGet(xCsrfToken, oid, options) {
            return localVarFp.orgsOidGet(xCsrfToken, oid, options).then((request) => request(axios, basePath));
        },
        /**
         * list projects of the specified organization (only for cloud orgs)
         * @summary List projects
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidProjectsGet(xCsrfToken, oid, options) {
            return localVarFp.orgsOidProjectsGet(xCsrfToken, oid, options).then((request) => request(axios, basePath));
        },
        /**
         * update organization
         * @summary Update the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {OrgUpdateOrganizationReq} organization organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidPut(xCsrfToken, oid, organization, options) {
            return localVarFp.orgsOidPut(xCsrfToken, oid, organization, options).then((request) => request(axios, basePath));
        },
        /**
         * list organization roles
         * @summary List the organizations roles
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidRolesGet(xCsrfToken, oid, options) {
            return localVarFp.orgsOidRolesGet(xCsrfToken, oid, options).then((request) => request(axios, basePath));
        },
        /**
         * unstar organization
         * @summary UnStar the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidStarDelete(xCsrfToken, oid, options) {
            return localVarFp.orgsOidStarDelete(xCsrfToken, oid, options).then((request) => request(axios, basePath));
        },
        /**
         * star organization
         * @summary Star the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidStarPost(xCsrfToken, oid, options) {
            return localVarFp.orgsOidStarPost(xCsrfToken, oid, options).then((request) => request(axios, basePath));
        },
        /**
         * get organization task list
         * @summary Get the organization task list
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidTasksGet(xCsrfToken, oid, options) {
            return localVarFp.orgsOidTasksGet(xCsrfToken, oid, options).then((request) => request(axios, basePath));
        },
        /**
         * list users of the organization
         * @summary List users
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersGet(xCsrfToken, oid, limit, page, options) {
            return localVarFp.orgsOidUsersGet(xCsrfToken, oid, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * delete user from organization
         * @summary Delete user from organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} id user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersIdDelete(xCsrfToken, oid, id, options) {
            return localVarFp.orgsOidUsersIdDelete(xCsrfToken, oid, id, options).then((request) => request(axios, basePath));
        },
        /**
         * update user role in organization
         * @summary Update user role in organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {number} id user id
         * @param {OrgRole} role user role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersIdPut(xCsrfToken, oid, id, role, options) {
            return localVarFp.orgsOidUsersIdPut(xCsrfToken, oid, id, role, options).then((request) => request(axios, basePath));
        },
        /**
         * invite user to join the organization
         * @summary Invite user
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {OrgInvitesReq} invite invite user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidUsersInvitePost(xCsrfToken, oid, invite, options) {
            return localVarFp.orgsOidUsersInvitePost(xCsrfToken, oid, invite, options).then((request) => request(axios, basePath));
        },
        /**
         * create organization
         * @summary Create the organization
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {OrgOrganization} organization organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsPost(xCsrfToken, organization, options) {
            return localVarFp.orgsPost(xCsrfToken, organization, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganizationApi - object-oriented interface
 * @export
 * @class OrganizationApi
 * @extends {BaseAPI}
 */
export class OrganizationApi extends BaseAPI {
    /**
     * get organization by external id
     * @summary Get the organization by external id
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} eid external id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsExternalEidGet(xCsrfToken, eid, options) {
        return OrganizationApiFp(this.configuration).orgsExternalEidGet(xCsrfToken, eid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list organization
     * @summary List the organizations
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} [query] the organization name
     * @param {string} [filter] filter condition, can be all,starred,mine
     * @param {number} [limit] the count per page
     * @param {number} [page] the page index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsGet(xCsrfToken, query, filter, limit, page, options) {
        return OrganizationApiFp(this.configuration).orgsGet(xCsrfToken, query, filter, limit, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete Organization and data
     * @summary delete Organization
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidDelete(xCsrfToken, oid, options) {
        return OrganizationApiFp(this.configuration).orgsOidDelete(xCsrfToken, oid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get organization
     * @summary Get the organization
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidGet(xCsrfToken, oid, options) {
        return OrganizationApiFp(this.configuration).orgsOidGet(xCsrfToken, oid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list projects of the specified organization (only for cloud orgs)
     * @summary List projects
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidProjectsGet(xCsrfToken, oid, options) {
        return OrganizationApiFp(this.configuration).orgsOidProjectsGet(xCsrfToken, oid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * update organization
     * @summary Update the organization
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {OrgUpdateOrganizationReq} organization organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidPut(xCsrfToken, oid, organization, options) {
        return OrganizationApiFp(this.configuration).orgsOidPut(xCsrfToken, oid, organization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list organization roles
     * @summary List the organizations roles
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidRolesGet(xCsrfToken, oid, options) {
        return OrganizationApiFp(this.configuration).orgsOidRolesGet(xCsrfToken, oid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * unstar organization
     * @summary UnStar the organization
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidStarDelete(xCsrfToken, oid, options) {
        return OrganizationApiFp(this.configuration).orgsOidStarDelete(xCsrfToken, oid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * star organization
     * @summary Star the organization
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidStarPost(xCsrfToken, oid, options) {
        return OrganizationApiFp(this.configuration).orgsOidStarPost(xCsrfToken, oid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get organization task list
     * @summary Get the organization task list
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidTasksGet(xCsrfToken, oid, options) {
        return OrganizationApiFp(this.configuration).orgsOidTasksGet(xCsrfToken, oid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list users of the organization
     * @summary List users
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {number} [limit] the count per page
     * @param {number} [page] the page index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidUsersGet(xCsrfToken, oid, limit, page, options) {
        return OrganizationApiFp(this.configuration).orgsOidUsersGet(xCsrfToken, oid, limit, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete user from organization
     * @summary Delete user from organization
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {number} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidUsersIdDelete(xCsrfToken, oid, id, options) {
        return OrganizationApiFp(this.configuration).orgsOidUsersIdDelete(xCsrfToken, oid, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * update user role in organization
     * @summary Update user role in organization
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {number} id user id
     * @param {OrgRole} role user role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidUsersIdPut(xCsrfToken, oid, id, role, options) {
        return OrganizationApiFp(this.configuration).orgsOidUsersIdPut(xCsrfToken, oid, id, role, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * invite user to join the organization
     * @summary Invite user
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {OrgInvitesReq} invite invite user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsOidUsersInvitePost(xCsrfToken, oid, invite, options) {
        return OrganizationApiFp(this.configuration).orgsOidUsersInvitePost(xCsrfToken, oid, invite, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create organization
     * @summary Create the organization
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {OrgOrganization} organization organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    orgsPost(xCsrfToken, organization, options) {
        return OrganizationApiFp(this.configuration).orgsPost(xCsrfToken, organization, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * list comparison report
         * @summary list comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonGet: (xCsrfToken_1, oid_1, cid_1, limit_1, page_1, brief_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, limit_1, page_1, brief_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, limit, page, brief, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonGet', 'cid', cid);
            const localVarPath = `/compute-engine/{oid}/{cid}/comparison`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (brief !== undefined) {
                localVarQueryParameter['brief'] = brief;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * touch report in on cluster
         * @summary Touch New Comparison Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {OldreportTouchComparisonReportReq} reportParam comparison report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonPost: (xCsrfToken_1, oid_1, cid_1, reportParam_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, reportParam_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, reportParam, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonPost', 'cid', cid);
            // verify required parameter 'reportParam' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonPost', 'reportParam', reportParam);
            const localVarPath = `/compute-engine/{oid}/{cid}/comparison`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(reportParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete comparison report
         * @summary delete comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonRidDelete: (xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, rid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonRidDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonRidDelete', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonRidDelete', 'cid', cid);
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonRidDelete', 'rid', rid);
            const localVarPath = `/compute-engine/{oid}/{cid}/comparison/{rid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list comparison report
         * @summary get comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonRidGet: (xCsrfToken_1, oid_1, cid_1, rid_1, brief_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, rid_1, brief_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, rid, brief, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonRidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonRidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonRidGet', 'cid', cid);
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('computeEngineOidCidComparisonRidGet', 'rid', rid);
            const localVarPath = `/compute-engine/{oid}/{cid}/comparison/{rid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (brief !== undefined) {
                localVarQueryParameter['brief'] = brief;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list traffic comparison report
         * @summary list traffic comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonGet: (xCsrfToken_1, oid_1, cid_1, limit_1, page_1, brief_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, limit_1, page_1, brief_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, limit, page, brief, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonGet', 'cid', cid);
            const localVarPath = `/compute-engine/{oid}/{cid}/trafficcomparison`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (brief !== undefined) {
                localVarQueryParameter['brief'] = brief;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * touch report in on cluster
         * @summary Touch New Traffic Comparison Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {OldreportTouchTrafficComparisonReportReq} reportParam traffic comparison report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonPost: (xCsrfToken_1, oid_1, cid_1, reportParam_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, reportParam_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, reportParam, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonPost', 'cid', cid);
            // verify required parameter 'reportParam' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonPost', 'reportParam', reportParam);
            const localVarPath = `/compute-engine/{oid}/{cid}/trafficcomparison`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(reportParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete traffic comparison report
         * @summary delete traffic comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonRidDelete: (xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, rid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonRidDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonRidDelete', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonRidDelete', 'cid', cid);
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonRidDelete', 'rid', rid);
            const localVarPath = `/compute-engine/{oid}/{cid}/trafficcomparison/{rid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list traffic comparison report
         * @summary get traffic comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonRidGet: (xCsrfToken_1, oid_1, cid_1, rid_1, brief_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, rid_1, brief_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, rid, brief, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonRidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonRidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonRidGet', 'cid', cid);
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('computeEngineOidCidTrafficcomparisonRidGet', 'rid', rid);
            const localVarPath = `/compute-engine/{oid}/{cid}/trafficcomparison/{rid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (brief !== undefined) {
                localVarQueryParameter['brief'] = brief;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration);
    return {
        /**
         * list comparison report
         * @summary list comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonGet(xCsrfToken, oid, cid, limit, page, brief, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidComparisonGet(xCsrfToken, oid, cid, limit, page, brief, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * touch report in on cluster
         * @summary Touch New Comparison Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {OldreportTouchComparisonReportReq} reportParam comparison report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonPost(xCsrfToken, oid, cid, reportParam, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidComparisonPost(xCsrfToken, oid, cid, reportParam, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * delete comparison report
         * @summary delete comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonRidDelete(xCsrfToken, oid, cid, rid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidComparisonRidDelete(xCsrfToken, oid, cid, rid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list comparison report
         * @summary get comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonRidGet(xCsrfToken, oid, cid, rid, brief, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidComparisonRidGet(xCsrfToken, oid, cid, rid, brief, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list traffic comparison report
         * @summary list traffic comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonGet(xCsrfToken, oid, cid, limit, page, brief, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidTrafficcomparisonGet(xCsrfToken, oid, cid, limit, page, brief, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * touch report in on cluster
         * @summary Touch New Traffic Comparison Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {OldreportTouchTrafficComparisonReportReq} reportParam traffic comparison report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonPost(xCsrfToken, oid, cid, reportParam, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidTrafficcomparisonPost(xCsrfToken, oid, cid, reportParam, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * delete traffic comparison report
         * @summary delete traffic comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonRidDelete(xCsrfToken, oid, cid, rid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidTrafficcomparisonRidDelete(xCsrfToken, oid, cid, rid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list traffic comparison report
         * @summary get traffic comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonRidGet(xCsrfToken, oid, cid, rid, brief, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.computeEngineOidCidTrafficcomparisonRidGet(xCsrfToken, oid, cid, rid, brief, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReportApiFp(configuration);
    return {
        /**
         * list comparison report
         * @summary list comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonGet(xCsrfToken, oid, cid, limit, page, brief, options) {
            return localVarFp.computeEngineOidCidComparisonGet(xCsrfToken, oid, cid, limit, page, brief, options).then((request) => request(axios, basePath));
        },
        /**
         * touch report in on cluster
         * @summary Touch New Comparison Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {OldreportTouchComparisonReportReq} reportParam comparison report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonPost(xCsrfToken, oid, cid, reportParam, options) {
            return localVarFp.computeEngineOidCidComparisonPost(xCsrfToken, oid, cid, reportParam, options).then((request) => request(axios, basePath));
        },
        /**
         * delete comparison report
         * @summary delete comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonRidDelete(xCsrfToken, oid, cid, rid, options) {
            return localVarFp.computeEngineOidCidComparisonRidDelete(xCsrfToken, oid, cid, rid, options).then((request) => request(axios, basePath));
        },
        /**
         * list comparison report
         * @summary get comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidComparisonRidGet(xCsrfToken, oid, cid, rid, brief, options) {
            return localVarFp.computeEngineOidCidComparisonRidGet(xCsrfToken, oid, cid, rid, brief, options).then((request) => request(axios, basePath));
        },
        /**
         * list traffic comparison report
         * @summary list traffic comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonGet(xCsrfToken, oid, cid, limit, page, brief, options) {
            return localVarFp.computeEngineOidCidTrafficcomparisonGet(xCsrfToken, oid, cid, limit, page, brief, options).then((request) => request(axios, basePath));
        },
        /**
         * touch report in on cluster
         * @summary Touch New Traffic Comparison Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {OldreportTouchTrafficComparisonReportReq} reportParam traffic comparison report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonPost(xCsrfToken, oid, cid, reportParam, options) {
            return localVarFp.computeEngineOidCidTrafficcomparisonPost(xCsrfToken, oid, cid, reportParam, options).then((request) => request(axios, basePath));
        },
        /**
         * delete traffic comparison report
         * @summary delete traffic comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonRidDelete(xCsrfToken, oid, cid, rid, options) {
            return localVarFp.computeEngineOidCidTrafficcomparisonRidDelete(xCsrfToken, oid, cid, rid, options).then((request) => request(axios, basePath));
        },
        /**
         * list traffic comparison report
         * @summary get traffic comparison report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {boolean} [brief] if need data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeEngineOidCidTrafficcomparisonRidGet(xCsrfToken, oid, cid, rid, brief, options) {
            return localVarFp.computeEngineOidCidTrafficcomparisonRidGet(xCsrfToken, oid, cid, rid, brief, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
    /**
     * list comparison report
     * @summary list comparison report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {number} [limit] the count per page
     * @param {number} [page] the page index
     * @param {boolean} [brief] if need data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    computeEngineOidCidComparisonGet(xCsrfToken, oid, cid, limit, page, brief, options) {
        return ReportApiFp(this.configuration).computeEngineOidCidComparisonGet(xCsrfToken, oid, cid, limit, page, brief, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * touch report in on cluster
     * @summary Touch New Comparison Report Job
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {OldreportTouchComparisonReportReq} reportParam comparison report param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    computeEngineOidCidComparisonPost(xCsrfToken, oid, cid, reportParam, options) {
        return ReportApiFp(this.configuration).computeEngineOidCidComparisonPost(xCsrfToken, oid, cid, reportParam, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete comparison report
     * @summary delete comparison report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} rid report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    computeEngineOidCidComparisonRidDelete(xCsrfToken, oid, cid, rid, options) {
        return ReportApiFp(this.configuration).computeEngineOidCidComparisonRidDelete(xCsrfToken, oid, cid, rid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list comparison report
     * @summary get comparison report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} rid report id
     * @param {boolean} [brief] if need data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    computeEngineOidCidComparisonRidGet(xCsrfToken, oid, cid, rid, brief, options) {
        return ReportApiFp(this.configuration).computeEngineOidCidComparisonRidGet(xCsrfToken, oid, cid, rid, brief, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list traffic comparison report
     * @summary list traffic comparison report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {number} [limit] the count per page
     * @param {number} [page] the page index
     * @param {boolean} [brief] if need data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    computeEngineOidCidTrafficcomparisonGet(xCsrfToken, oid, cid, limit, page, brief, options) {
        return ReportApiFp(this.configuration).computeEngineOidCidTrafficcomparisonGet(xCsrfToken, oid, cid, limit, page, brief, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * touch report in on cluster
     * @summary Touch New Traffic Comparison Report Job
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {OldreportTouchTrafficComparisonReportReq} reportParam traffic comparison report param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    computeEngineOidCidTrafficcomparisonPost(xCsrfToken, oid, cid, reportParam, options) {
        return ReportApiFp(this.configuration).computeEngineOidCidTrafficcomparisonPost(xCsrfToken, oid, cid, reportParam, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete traffic comparison report
     * @summary delete traffic comparison report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} rid report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    computeEngineOidCidTrafficcomparisonRidDelete(xCsrfToken, oid, cid, rid, options) {
        return ReportApiFp(this.configuration).computeEngineOidCidTrafficcomparisonRidDelete(xCsrfToken, oid, cid, rid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list traffic comparison report
     * @summary get traffic comparison report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} rid report id
     * @param {boolean} [brief] if need data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    computeEngineOidCidTrafficcomparisonRidGet(xCsrfToken, oid, cid, rid, brief, options) {
        return ReportApiFp(this.configuration).computeEngineOidCidTrafficcomparisonRidGet(xCsrfToken, oid, cid, rid, brief, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * list health report
         * @summary list health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} reportType report type
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidGet: (xCsrfToken_1, oid_1, cid_1, reportType_1, limit_1, page_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, reportType_1, limit_1, page_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, reportType, limit, page, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('reportsOidCidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('reportsOidCidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('reportsOidCidGet', 'cid', cid);
            // verify required parameter 'reportType' is not null or undefined
            assertParamExists('reportsOidCidGet', 'reportType', reportType);
            const localVarPath = `/reports/{oid}/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (reportType !== undefined) {
                localVarQueryParameter['report_type'] = reportType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * touch report on cluster
         * @summary Touch New Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} reportType report type
         * @param {ReportTouchReportRequest} reportParams report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidPost: (xCsrfToken_1, oid_1, cid_1, reportType_1, reportParams_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, reportType_1, reportParams_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, reportType, reportParams, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('reportsOidCidPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('reportsOidCidPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('reportsOidCidPost', 'cid', cid);
            // verify required parameter 'reportType' is not null or undefined
            assertParamExists('reportsOidCidPost', 'reportType', reportType);
            // verify required parameter 'reportParams' is not null or undefined
            assertParamExists('reportsOidCidPost', 'reportParams', reportParams);
            const localVarPath = `/reports/{oid}/{cid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (reportType !== undefined) {
                localVarQueryParameter['report_type'] = reportType;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(reportParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete health report
         * @summary delete report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidDelete: (xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, rid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('reportsOidCidRidDelete', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('reportsOidCidRidDelete', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('reportsOidCidRidDelete', 'cid', cid);
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('reportsOidCidRidDelete', 'rid', rid);
            const localVarPath = `/reports/{oid}/{cid}/{rid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list report
         * @summary get report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidGet: (xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, rid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('reportsOidCidRidGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('reportsOidCidRidGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('reportsOidCidRidGet', 'cid', cid);
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('reportsOidCidRidGet', 'rid', rid);
            const localVarPath = `/reports/{oid}/{cid}/{rid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete health report
         * @summary rebuild report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidPost: (xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, rid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, rid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('reportsOidCidRidPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('reportsOidCidRidPost', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('reportsOidCidRidPost', 'cid', cid);
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('reportsOidCidRidPost', 'rid', rid);
            const localVarPath = `/reports/{oid}/{cid}/{rid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * put health report
         * @summary put report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {ReportPutReportRequest} reportParams report information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidPut: (xCsrfToken_1, oid_1, cid_1, rid_1, reportParams_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, rid_1, reportParams_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, rid, reportParams, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('reportsOidCidRidPut', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('reportsOidCidRidPut', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('reportsOidCidRidPut', 'cid', cid);
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('reportsOidCidRidPut', 'rid', rid);
            // verify required parameter 'reportParams' is not null or undefined
            assertParamExists('reportsOidCidRidPut', 'reportParams', reportParams);
            const localVarPath = `/reports/{oid}/{cid}/{rid}`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(reportParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get report statistics
         * @summary get report statistics
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} event event name
         * @param {string} hash hash value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsStatisticsGet: (xCsrfToken_1, event_1, hash_1, ...args_1) => __awaiter(this, [xCsrfToken_1, event_1, hash_1, ...args_1], void 0, function* (xCsrfToken, event, hash, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('reportsStatisticsGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'event' is not null or undefined
            assertParamExists('reportsStatisticsGet', 'event', event);
            // verify required parameter 'hash' is not null or undefined
            assertParamExists('reportsStatisticsGet', 'hash', hash);
            const localVarPath = `/reports/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (event !== undefined) {
                localVarQueryParameter['event'] = event;
            }
            if (hash !== undefined) {
                localVarQueryParameter['hash'] = hash;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration);
    return {
        /**
         * list health report
         * @summary list health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} reportType report type
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidGet(xCsrfToken, oid, cid, reportType, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsOidCidGet(xCsrfToken, oid, cid, reportType, limit, page, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * touch report on cluster
         * @summary Touch New Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} reportType report type
         * @param {ReportTouchReportRequest} reportParams report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidPost(xCsrfToken, oid, cid, reportType, reportParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsOidCidPost(xCsrfToken, oid, cid, reportType, reportParams, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * delete health report
         * @summary delete report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidDelete(xCsrfToken, oid, cid, rid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsOidCidRidDelete(xCsrfToken, oid, cid, rid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * list report
         * @summary get report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidGet(xCsrfToken, oid, cid, rid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsOidCidRidGet(xCsrfToken, oid, cid, rid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * delete health report
         * @summary rebuild report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidPost(xCsrfToken, oid, cid, rid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsOidCidRidPost(xCsrfToken, oid, cid, rid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * put health report
         * @summary put report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {ReportPutReportRequest} reportParams report information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidPut(xCsrfToken, oid, cid, rid, reportParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsOidCidRidPut(xCsrfToken, oid, cid, rid, reportParams, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * get report statistics
         * @summary get report statistics
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} event event name
         * @param {string} hash hash value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsStatisticsGet(xCsrfToken, event, hash, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsStatisticsGet(xCsrfToken, event, hash, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReportsApiFp(configuration);
    return {
        /**
         * list health report
         * @summary list health report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} reportType report type
         * @param {number} [limit] the count per page
         * @param {number} [page] the page index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidGet(xCsrfToken, oid, cid, reportType, limit, page, options) {
            return localVarFp.reportsOidCidGet(xCsrfToken, oid, cid, reportType, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * touch report on cluster
         * @summary Touch New Report Job
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} reportType report type
         * @param {ReportTouchReportRequest} reportParams report param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidPost(xCsrfToken, oid, cid, reportType, reportParams, options) {
            return localVarFp.reportsOidCidPost(xCsrfToken, oid, cid, reportType, reportParams, options).then((request) => request(axios, basePath));
        },
        /**
         * delete health report
         * @summary delete report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidDelete(xCsrfToken, oid, cid, rid, options) {
            return localVarFp.reportsOidCidRidDelete(xCsrfToken, oid, cid, rid, options).then((request) => request(axios, basePath));
        },
        /**
         * list report
         * @summary get report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidGet(xCsrfToken, oid, cid, rid, options) {
            return localVarFp.reportsOidCidRidGet(xCsrfToken, oid, cid, rid, options).then((request) => request(axios, basePath));
        },
        /**
         * delete health report
         * @summary rebuild report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidPost(xCsrfToken, oid, cid, rid, options) {
            return localVarFp.reportsOidCidRidPost(xCsrfToken, oid, cid, rid, options).then((request) => request(axios, basePath));
        },
        /**
         * put health report
         * @summary put report
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {string} rid report id
         * @param {ReportPutReportRequest} reportParams report information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsOidCidRidPut(xCsrfToken, oid, cid, rid, reportParams, options) {
            return localVarFp.reportsOidCidRidPut(xCsrfToken, oid, cid, rid, reportParams, options).then((request) => request(axios, basePath));
        },
        /**
         * get report statistics
         * @summary get report statistics
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} event event name
         * @param {string} hash hash value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsStatisticsGet(xCsrfToken, event, hash, options) {
            return localVarFp.reportsStatisticsGet(xCsrfToken, event, hash, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * list health report
     * @summary list health report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} reportType report type
     * @param {number} [limit] the count per page
     * @param {number} [page] the page index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    reportsOidCidGet(xCsrfToken, oid, cid, reportType, limit, page, options) {
        return ReportsApiFp(this.configuration).reportsOidCidGet(xCsrfToken, oid, cid, reportType, limit, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * touch report on cluster
     * @summary Touch New Report Job
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} reportType report type
     * @param {ReportTouchReportRequest} reportParams report param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    reportsOidCidPost(xCsrfToken, oid, cid, reportType, reportParams, options) {
        return ReportsApiFp(this.configuration).reportsOidCidPost(xCsrfToken, oid, cid, reportType, reportParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete health report
     * @summary delete report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} rid report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    reportsOidCidRidDelete(xCsrfToken, oid, cid, rid, options) {
        return ReportsApiFp(this.configuration).reportsOidCidRidDelete(xCsrfToken, oid, cid, rid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list report
     * @summary get report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} rid report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    reportsOidCidRidGet(xCsrfToken, oid, cid, rid, options) {
        return ReportsApiFp(this.configuration).reportsOidCidRidGet(xCsrfToken, oid, cid, rid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete health report
     * @summary rebuild report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} rid report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    reportsOidCidRidPost(xCsrfToken, oid, cid, rid, options) {
        return ReportsApiFp(this.configuration).reportsOidCidRidPost(xCsrfToken, oid, cid, rid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * put health report
     * @summary put report
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {string} rid report id
     * @param {ReportPutReportRequest} reportParams report information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    reportsOidCidRidPut(xCsrfToken, oid, cid, rid, reportParams, options) {
        return ReportsApiFp(this.configuration).reportsOidCidRidPut(xCsrfToken, oid, cid, rid, reportParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get report statistics
     * @summary get report statistics
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} event event name
     * @param {string} hash hash value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    reportsStatisticsGet(xCsrfToken, event, hash, options) {
        return ReportsApiFp(this.configuration).reportsStatisticsGet(xCsrfToken, event, hash, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ResourcePoolApi - axios parameter creator
 * @export
 */
export const ResourcePoolApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get Nextgen ResourcePool components
         * @summary Get resource pool components
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidResourcePoolComponentsGet: (xCsrfToken_1, oid_1, cid_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, cid_1, ...args_1], void 0, function* (xCsrfToken, oid, cid, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidClustersCidResourcePoolComponentsGet', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidClustersCidResourcePoolComponentsGet', 'oid', oid);
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('orgsOidClustersCidResourcePoolComponentsGet', 'cid', cid);
            const localVarPath = `/orgs/{oid}/clusters/{cid}/resource-pool/components`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)))
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ResourcePoolApi - functional programming interface
 * @export
 */
export const ResourcePoolApiFp = function (configuration) {
    const localVarAxiosParamCreator = ResourcePoolApiAxiosParamCreator(configuration);
    return {
        /**
         * Get Nextgen ResourcePool components
         * @summary Get resource pool components
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidResourcePoolComponentsGet(xCsrfToken, oid, cid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidClustersCidResourcePoolComponentsGet(xCsrfToken, oid, cid, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ResourcePoolApi - factory interface
 * @export
 */
export const ResourcePoolApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ResourcePoolApiFp(configuration);
    return {
        /**
         * Get Nextgen ResourcePool components
         * @summary Get resource pool components
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} cid cluster id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidClustersCidResourcePoolComponentsGet(xCsrfToken, oid, cid, options) {
            return localVarFp.orgsOidClustersCidResourcePoolComponentsGet(xCsrfToken, oid, cid, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ResourcePoolApi - object-oriented interface
 * @export
 * @class ResourcePoolApi
 * @extends {BaseAPI}
 */
export class ResourcePoolApi extends BaseAPI {
    /**
     * Get Nextgen ResourcePool components
     * @summary Get resource pool components
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} cid cluster id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcePoolApi
     */
    orgsOidClustersCidResourcePoolComponentsGet(xCsrfToken, oid, cid, options) {
        return ResourcePoolApiFp(this.configuration).orgsOidClustersCidResourcePoolComponentsGet(xCsrfToken, oid, cid, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * call flush api after all parts of file are uploaded
         * @summary Flush
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {string} [issue] an optional issue Jira issue ID this package should be connected to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagFlushPost: (xCsrfToken_1, uuid_1, issue_1, ...args_1) => __awaiter(this, [xCsrfToken_1, uuid_1, issue_1, ...args_1], void 0, function* (xCsrfToken, uuid, issue, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('diagFlushPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('diagFlushPost', 'uuid', uuid);
            const localVarPath = `/diag/flush`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }
            if (issue !== undefined) {
                localVarQueryParameter['issue'] = issue;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * precreate
         * @summary Precreate
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} length the size of the file
         * @param {string} filename actual name of the file
         * @param {any} file file
         * @param {string} [alias] an optional alias of filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagPrecreatePost: (xCsrfToken_1, uuid_1, length_1, filename_1, file_1, alias_1, ...args_1) => __awaiter(this, [xCsrfToken_1, uuid_1, length_1, filename_1, file_1, alias_1, ...args_1], void 0, function* (xCsrfToken, uuid, length, filename, file, alias, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('diagPrecreatePost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('diagPrecreatePost', 'uuid', uuid);
            // verify required parameter 'length' is not null or undefined
            assertParamExists('diagPrecreatePost', 'length', length);
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('diagPrecreatePost', 'filename', filename);
            // verify required parameter 'file' is not null or undefined
            assertParamExists('diagPrecreatePost', 'file', file);
            const localVarPath = `/diag/precreate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }
            if (length !== undefined) {
                localVarQueryParameter['length'] = length;
            }
            if (alias !== undefined) {
                localVarQueryParameter['alias'] = alias;
            }
            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * upload file part api
         * @summary Upload
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} sequence the serial number of the file part
         * @param {number} length the length of the file part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagUploadPost: (xCsrfToken_1, uuid_1, sequence_1, length_1, ...args_1) => __awaiter(this, [xCsrfToken_1, uuid_1, sequence_1, length_1, ...args_1], void 0, function* (xCsrfToken, uuid, sequence, length, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('diagUploadPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('diagUploadPost', 'uuid', uuid);
            // verify required parameter 'sequence' is not null or undefined
            assertParamExists('diagUploadPost', 'sequence', sequence);
            // verify required parameter 'length' is not null or undefined
            assertParamExists('diagUploadPost', 'length', length);
            const localVarPath = `/diag/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }
            if (sequence !== undefined) {
                localVarQueryParameter['sequence'] = sequence;
            }
            if (length !== undefined) {
                localVarQueryParameter['length'] = length;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * call flush api after all parts of file are uploaded
         * @summary Flush
         * @param {string} oid organization id
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {string} [issue] an optional issue Jira issue ID this package should be connected to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDiagFlushPost: (oid_1, xCsrfToken_1, uuid_1, issue_1, ...args_1) => __awaiter(this, [oid_1, xCsrfToken_1, uuid_1, issue_1, ...args_1], void 0, function* (oid, xCsrfToken, uuid, issue, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidDiagFlushPost', 'oid', oid);
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidDiagFlushPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('orgsOidDiagFlushPost', 'uuid', uuid);
            const localVarPath = `/orgs/{oid}/diag/flush`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }
            if (issue !== undefined) {
                localVarQueryParameter['issue'] = issue;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * precreate
         * @summary Precreate
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} length the size of the file
         * @param {string} filename actual name of the file
         * @param {any} file file
         * @param {string} [alias] an optional alias of filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDiagPrecreatePost: (xCsrfToken_1, oid_1, uuid_1, length_1, filename_1, file_1, alias_1, ...args_1) => __awaiter(this, [xCsrfToken_1, oid_1, uuid_1, length_1, filename_1, file_1, alias_1, ...args_1], void 0, function* (xCsrfToken, oid, uuid, length, filename, file, alias, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidDiagPrecreatePost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidDiagPrecreatePost', 'oid', oid);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('orgsOidDiagPrecreatePost', 'uuid', uuid);
            // verify required parameter 'length' is not null or undefined
            assertParamExists('orgsOidDiagPrecreatePost', 'length', length);
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('orgsOidDiagPrecreatePost', 'filename', filename);
            // verify required parameter 'file' is not null or undefined
            assertParamExists('orgsOidDiagPrecreatePost', 'file', file);
            const localVarPath = `/orgs/{oid}/diag/precreate`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }
            if (length !== undefined) {
                localVarQueryParameter['length'] = length;
            }
            if (alias !== undefined) {
                localVarQueryParameter['alias'] = alias;
            }
            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * upload file part api
         * @summary Upload
         * @param {string} oid organization id
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} sequence the serial number of the file part
         * @param {number} length the length of the file part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDiagUploadPost: (oid_1, xCsrfToken_1, uuid_1, sequence_1, length_1, ...args_1) => __awaiter(this, [oid_1, xCsrfToken_1, uuid_1, sequence_1, length_1, ...args_1], void 0, function* (oid, xCsrfToken, uuid, sequence, length, options = {}) {
            // verify required parameter 'oid' is not null or undefined
            assertParamExists('orgsOidDiagUploadPost', 'oid', oid);
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('orgsOidDiagUploadPost', 'xCsrfToken', xCsrfToken);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('orgsOidDiagUploadPost', 'uuid', uuid);
            // verify required parameter 'sequence' is not null or undefined
            assertParamExists('orgsOidDiagUploadPost', 'sequence', sequence);
            // verify required parameter 'length' is not null or undefined
            assertParamExists('orgsOidDiagUploadPost', 'length', length);
            const localVarPath = `/orgs/{oid}/diag/upload`
                .replace(`{${"oid"}}`, encodeURIComponent(String(oid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }
            if (sequence !== undefined) {
                localVarQueryParameter['sequence'] = sequence;
            }
            if (length !== undefined) {
                localVarQueryParameter['length'] = length;
            }
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function (configuration) {
    const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration);
    return {
        /**
         * call flush api after all parts of file are uploaded
         * @summary Flush
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {string} [issue] an optional issue Jira issue ID this package should be connected to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagFlushPost(xCsrfToken, uuid, issue, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.diagFlushPost(xCsrfToken, uuid, issue, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * precreate
         * @summary Precreate
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} length the size of the file
         * @param {string} filename actual name of the file
         * @param {any} file file
         * @param {string} [alias] an optional alias of filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagPrecreatePost(xCsrfToken, uuid, length, filename, file, alias, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.diagPrecreatePost(xCsrfToken, uuid, length, filename, file, alias, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * upload file part api
         * @summary Upload
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} sequence the serial number of the file part
         * @param {number} length the length of the file part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagUploadPost(xCsrfToken, uuid, sequence, length, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.diagUploadPost(xCsrfToken, uuid, sequence, length, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * call flush api after all parts of file are uploaded
         * @summary Flush
         * @param {string} oid organization id
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {string} [issue] an optional issue Jira issue ID this package should be connected to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDiagFlushPost(oid, xCsrfToken, uuid, issue, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidDiagFlushPost(oid, xCsrfToken, uuid, issue, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * precreate
         * @summary Precreate
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} length the size of the file
         * @param {string} filename actual name of the file
         * @param {any} file file
         * @param {string} [alias] an optional alias of filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDiagPrecreatePost(xCsrfToken, oid, uuid, length, filename, file, alias, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidDiagPrecreatePost(xCsrfToken, oid, uuid, length, filename, file, alias, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * upload file part api
         * @summary Upload
         * @param {string} oid organization id
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} sequence the serial number of the file part
         * @param {number} length the length of the file part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDiagUploadPost(oid, xCsrfToken, uuid, sequence, length, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orgsOidDiagUploadPost(oid, xCsrfToken, uuid, sequence, length, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UploadApiFp(configuration);
    return {
        /**
         * call flush api after all parts of file are uploaded
         * @summary Flush
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {string} [issue] an optional issue Jira issue ID this package should be connected to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagFlushPost(xCsrfToken, uuid, issue, options) {
            return localVarFp.diagFlushPost(xCsrfToken, uuid, issue, options).then((request) => request(axios, basePath));
        },
        /**
         * precreate
         * @summary Precreate
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} length the size of the file
         * @param {string} filename actual name of the file
         * @param {any} file file
         * @param {string} [alias] an optional alias of filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagPrecreatePost(xCsrfToken, uuid, length, filename, file, alias, options) {
            return localVarFp.diagPrecreatePost(xCsrfToken, uuid, length, filename, file, alias, options).then((request) => request(axios, basePath));
        },
        /**
         * upload file part api
         * @summary Upload
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} sequence the serial number of the file part
         * @param {number} length the length of the file part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagUploadPost(xCsrfToken, uuid, sequence, length, options) {
            return localVarFp.diagUploadPost(xCsrfToken, uuid, sequence, length, options).then((request) => request(axios, basePath));
        },
        /**
         * call flush api after all parts of file are uploaded
         * @summary Flush
         * @param {string} oid organization id
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {string} [issue] an optional issue Jira issue ID this package should be connected to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDiagFlushPost(oid, xCsrfToken, uuid, issue, options) {
            return localVarFp.orgsOidDiagFlushPost(oid, xCsrfToken, uuid, issue, options).then((request) => request(axios, basePath));
        },
        /**
         * precreate
         * @summary Precreate
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} oid organization id
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} length the size of the file
         * @param {string} filename actual name of the file
         * @param {any} file file
         * @param {string} [alias] an optional alias of filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDiagPrecreatePost(xCsrfToken, oid, uuid, length, filename, file, alias, options) {
            return localVarFp.orgsOidDiagPrecreatePost(xCsrfToken, oid, uuid, length, filename, file, alias, options).then((request) => request(axios, basePath));
        },
        /**
         * upload file part api
         * @summary Upload
         * @param {string} oid organization id
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {string} uuid a custom hash combining package’s filename, size and modify time
         * @param {number} sequence the serial number of the file part
         * @param {number} length the length of the file part
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgsOidDiagUploadPost(oid, xCsrfToken, uuid, sequence, length, options) {
            return localVarFp.orgsOidDiagUploadPost(oid, xCsrfToken, uuid, sequence, length, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI {
    /**
     * call flush api after all parts of file are uploaded
     * @summary Flush
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} uuid a custom hash combining package’s filename, size and modify time
     * @param {string} [issue] an optional issue Jira issue ID this package should be connected to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    diagFlushPost(xCsrfToken, uuid, issue, options) {
        return UploadApiFp(this.configuration).diagFlushPost(xCsrfToken, uuid, issue, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * precreate
     * @summary Precreate
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} uuid a custom hash combining package’s filename, size and modify time
     * @param {number} length the size of the file
     * @param {string} filename actual name of the file
     * @param {any} file file
     * @param {string} [alias] an optional alias of filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    diagPrecreatePost(xCsrfToken, uuid, length, filename, file, alias, options) {
        return UploadApiFp(this.configuration).diagPrecreatePost(xCsrfToken, uuid, length, filename, file, alias, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * upload file part api
     * @summary Upload
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} uuid a custom hash combining package’s filename, size and modify time
     * @param {number} sequence the serial number of the file part
     * @param {number} length the length of the file part
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    diagUploadPost(xCsrfToken, uuid, sequence, length, options) {
        return UploadApiFp(this.configuration).diagUploadPost(xCsrfToken, uuid, sequence, length, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * call flush api after all parts of file are uploaded
     * @summary Flush
     * @param {string} oid organization id
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} uuid a custom hash combining package’s filename, size and modify time
     * @param {string} [issue] an optional issue Jira issue ID this package should be connected to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    orgsOidDiagFlushPost(oid, xCsrfToken, uuid, issue, options) {
        return UploadApiFp(this.configuration).orgsOidDiagFlushPost(oid, xCsrfToken, uuid, issue, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * precreate
     * @summary Precreate
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} oid organization id
     * @param {string} uuid a custom hash combining package’s filename, size and modify time
     * @param {number} length the size of the file
     * @param {string} filename actual name of the file
     * @param {any} file file
     * @param {string} [alias] an optional alias of filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    orgsOidDiagPrecreatePost(xCsrfToken, oid, uuid, length, filename, file, alias, options) {
        return UploadApiFp(this.configuration).orgsOidDiagPrecreatePost(xCsrfToken, oid, uuid, length, filename, file, alias, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * upload file part api
     * @summary Upload
     * @param {string} oid organization id
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {string} uuid a custom hash combining package’s filename, size and modify time
     * @param {number} sequence the serial number of the file part
     * @param {number} length the length of the file part
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    orgsOidDiagUploadPost(oid, xCsrfToken, uuid, sequence, length, options) {
        return UploadApiFp(this.configuration).orgsOidDiagUploadPost(oid, xCsrfToken, uuid, sequence, length, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * get profile
         * @summary Get profile
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileGet: (xCsrfToken_1, ...args_1) => __awaiter(this, [xCsrfToken_1, ...args_1], void 0, function* (xCsrfToken, options = {}) {
            // verify required parameter 'xCsrfToken' is not null or undefined
            assertParamExists('userProfileGet', 'xCsrfToken', xCsrfToken);
            const localVarPath = `/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xCsrfToken !== undefined && xCsrfToken !== null) {
                localVarHeaderParameter['x-csrf-token'] = String(xCsrfToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration);
    return {
        /**
         * get profile
         * @summary Get profile
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileGet(xCsrfToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userProfileGet(xCsrfToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserApiFp(configuration);
    return {
        /**
         * get profile
         * @summary Get profile
         * @param {string} xCsrfToken get value from login.ValidationResp response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileGet(xCsrfToken, options) {
            return localVarFp.userProfileGet(xCsrfToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * get profile
     * @summary Get profile
     * @param {string} xCsrfToken get value from login.ValidationResp response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userProfileGet(xCsrfToken, options) {
        return UserApiFp(this.configuration).userProfileGet(xCsrfToken, options).then((request) => request(this.axios, this.basePath));
    }
}
